// English strings for the Outfino Partner Portal.
const en = {
  // ---- Signed-out landing (pages/Login.js) ----
  'landing.partners': 'Partners',
  'landing.kicker': 'KYC for fashion',
  'landing.title': 'Know your customers.',
  'landing.shopUrl': 'webshop.com/products/merino-sweater',
  'landing.productCrumb': 'Knitwear',
  'landing.productPrice': '€89',
  'landing.addToCart': 'Add to cart',
  'landing.demoLabel': 'A webshop product page with the Outfino button',
  'landing.productName': 'Merino sweater',
  'landing.visitor.title': 'What your visitor gets',
  'landing.visitor.match.title': 'A match percentage',
  'landing.visitor.match.body': 'They see how well the product suits them.',
  'landing.visitor.why.title': 'A short why',
  'landing.visitor.why.body': 'They learn why it suits them – or why not.',
  'landing.visitor.wardrobe.title': 'A wardrobe from photos',
  'landing.visitor.wardrobe.body': 'Their own wardrobe, built from the photos they upload.',
  'landing.visitor.follow.title': 'Follows and drop alerts',
  'landing.visitor.follow.body': 'They can follow your brand and hear about new drops.',
  'landing.brand.title': 'What you get',
  'landing.brand.returns.title': 'Fewer returns',
  'landing.brand.returns.body': 'Shoppers order what truly suits them.',
  'landing.brand.quality.title': 'Better-quality buyers',
  'landing.brand.quality.body': 'The people who buy are the ones your brand suits.',
  'landing.brand.conversion.title': 'More conversions',
  'landing.brand.conversion.body': '“Will it suit me?” gets answered right there.',
  'landing.brand.reach.title': 'Followers and reach',
  'landing.brand.reach.body': 'Promotions and new products, straight to your followers.',
  'landing.brand.insights.title': 'Visitors in the portal',
  'landing.brand.insights.body': 'Visitors and conversions, product by product.',
  'landing.mobileLead': 'One button on your product page that shows how well the product suits the shopper.',
  'landing.stickyNote': 'New brand? 1 month free',
  'landing.stickyCta': 'Log in',
  'landing.newBrand': 'New brand? Sign in and set it up in minutes – with a 1-month free\u00a0trial.',
  'landing.themeDark': 'Dark mode',
  'landing.themeLight': 'Light mode',
  'landing.terms': 'Terms',
  'landing.privacy': 'Privacy',
  'landing.contact': 'Contact',

  // ---- Login ----
  'login.title': 'Partner Portal',
  'seo.home.title': 'Outfino for Brands',
  'seo.home.description': 'Outfino for Brands — turn your brand into a personalized shopping experience. Reach customers whose style matches your brand, connect Shopify, and manage everything in one dashboard.',
  'login.subtitle': 'Log in to manage your brand.',
  'login.email': 'Email address',
  'login.password': 'Password',
  'login.submit': 'Log in',
  'login.loading': 'Logging in…',
  'login.wrongCredentials': 'Incorrect email or password.',
  'login.networkError': 'Network error. Please try again.',
  'login.googleShort': 'Google',
  'login.appleShort': 'Apple',
  'login.google': 'Sign in with Google',
  'login.apple': 'Sign in with Apple',
  'login.or': 'or',
  'login.googleFailed': 'Google sign-in failed.',
  'login.googleCloseWindow': 'Signed in. You can close this window.',
  'login.appleUnavailable': 'Apple sign-in is unavailable.',
  'login.appleFailed': 'Apple sign-in failed.',

  // ---- Dashboard shell ----
  'shell.brand': 'Brand',
  'shell.envDev': 'DEV',
  'shell.logout': 'Log out',
  'shell.loading': 'Loading…',
  'shell.refresh': 'Refresh',
  'group.mobile': 'Outfino Mobile App',
  'tab.events': 'Event calendar',
  'tab.prize-pool': 'Prize Pool',
  'tab.embedded-stats': 'Statistics',
  'tab.embedded-visitors': 'Visitors',
  'shell.comingSoon': 'Coming soon.',
  'sidebar.expand': 'Expand',
  'sidebar.collapse': 'Collapse',
  'sidebar.menu': 'Menu',
  'sidebar.menuClose': 'Close menu',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.lightTitle': 'Light theme',
  'theme.darkTitle': 'Dark theme',
  'lang.name': 'English',
  'lang.switchTitle': 'Switch to Hungarian',
  'shell.connectedReturn': 'Your store is connected to Outfino.',
  'shell.openPortal': 'Go to Outfino Partners',
  'shell.notLinked': 'This store is not linked to an Outfino account yet.',
  'shell.linkAccount': 'Link in Outfino Partners',
  'shell.openInShopifyAdmin': 'Shopify admin',
  'return.title': 'Your store is connected',
  'return.body':
    'Carry on in the Outfino partner portal — your brand, products and payouts are managed there.',
  'shell.embeddedNoSession':
    'Open this page from your Shopify admin, under Apps › Outfino.',

  // ---- No brand yet ----
  'empty.title': 'You don’t have a brand yet',
  'empty.body': 'Set up your brand in a few minutes: name, logo, cover image and your webshop address. Then add your card and your 1-month free trial starts.',
  'empty.create': 'Create a new brand',

  // ---- Connect Shopify modal ----
  'shopify.title': 'Connect Shopify',
  'shopify.body':
    'Enter your Shopify store domain to connect it. You’ll be redirected to Shopify to approve access, then brought back here.',
  'shopify.shopLabel': 'Shopify store domain',
  'shopify.shopPlaceholder': 'your-store.myshopify.com',
  'shopify.connect': 'Connect',
  'shopify.cancel': 'Cancel',
  'shopify.invalid': 'Please enter a valid .myshopify.com domain.',

  // ---- Linking a store back from Shopify ----
  'connect.linking': 'Attaching the store to your account…',
  'connect.syncing': 'Syncing…',
  'connect.syncingHint': 'Linking the store to your Outfino account. This only takes a few seconds.',
  'connect.returning': 'Taking you to Outfino Partners…',
  'connect.returningHint': 'This store is not linked to an Outfino account yet. Sign in to Outfino Partners to link it.',
  'connect.returningLink': 'Continue to Outfino Partners',
  'connect.failed': 'Could not attach the store. Try again with “Add a brand”.',
  'connect.alreadyLinked': 'This store already belongs to another Outfino account.',

  // ---- Shopify connection banner (documents#637) ----
  // Shown above every brand page while stores[].shopifyConnection.status is not
  // CONNECTED. The CTA opens the Outfino app inside the merchant's Shopify
  // admin (reauth_url) — opening it runs a fresh token exchange.
  'connection.reauthTitle':
    'The Shopify connection was interrupted — open the Outfino app in your Shopify Admin to reconnect.',
  'connection.reauthCta': 'Open the Outfino app in Shopify',
  'products.inactive': 'Inactive',
  'brandInactive.title': 'This brand is currently inactive.',
  'brandInactive.body': 'Its products are not shown in the Outfino app and cannot be bought.',
  'brandInactive.contact': 'To reactivate it, contact the Outfino admins.',
  'brandInactive.cta': 'Contact us',
  'brandInactive.mailSubject': 'Inactive brand',
  'brandSuspended.title': 'Outfino has suspended your brand.',
  'brandSuspended.body': 'If you have a question, write to us.',
  'brandSuspended.cta': 'Write to us',
  'brandSuspended.mailSubject': 'Suspended brand',
  'connection.disconnectedTitle': 'The Outfino app is not installed in this store.',
  'connection.disconnectedCta': 'Install / reconnect',
  'connection.lastOk': 'Last successful: {time}',
  'connection.lastOkNever': 'No successful connection recorded yet',
  'connection.err.tokenExpired': 'The Shopify access token has expired.',
  'connection.err.tokenRejected': 'Shopify rejected or revoked the access token.',
  'connection.err.scopeMissing':
    'A permission is missing ({scope}) — grant it by opening the app.',
  'connection.err.uninstalled': 'The app was uninstalled from the store.',
  'connection.err.generic': 'Reason: {code}',

  // ---- Brand dashboard tabs ----
  'tab.profile': 'Profile',
  'tab.products': 'Products',
  'tab.stats': 'Statistics',
  'tab.orders': 'Orders',
  'orders.title': 'Orders',
  'orders.hint': 'Everything sold through Outfino that is yours to fulfil. Amounts are your share after commission.',
  'orders.loading': 'Loading orders…',
  'orders.loadError': 'Could not load your orders.',
  'orders.empty': 'No orders yet.',
  'orders.units': '{n} items',
  'orders.subtotal': 'Products',
  'orders.shipping': 'Shipping',
  'orders.yourShare': 'Your share (after {n}% commission)',
  'orders.method': 'Shipping method',
  'orders.deliverTo': 'Deliver to',
  'orders.shopifyOrder': 'Shopify order',
  'orders.noShopifyOrder': 'Not created in Shopify',

  // ---- Shipping (#623 B4 — read-only; Shopify is the only source) ----
  'tab.shipping': 'Shipping',
  'shipping.title': 'Shipping coverage',
  'shipping.source': 'We read your shipping countries and methods from your Shopify settings.',
  'shipping.sourceHowTo': 'To change where you ship or what it costs, edit them in your Shopify Admin (Settings → Shipping and delivery). Changes reach Outfino automatically, or use Refresh.',
  'shipping.refresh': 'Refresh',
  'shipping.refreshing': 'Refreshing…',
  'shipping.loading': 'Loading shipping coverage…',
  'shipping.loadError': 'Could not load your shipping coverage.',
  'shipping.noCoverage': 'No shipping zones found in your Shopify settings yet.',
  'shipping.countryCount': '{n} countries',
  'shipping.restOfWorldChip': 'Rest of world',
  'shipping.zoomIn': 'Zoom in',
  'shipping.zoomOut': 'Zoom out',
  'shipping.legendCovered': 'Ships here (from Shopify)',
  'shipping.legendRestOfWorld': 'Rest of world — every other country',
  'shipping.legendNone': 'No shipping',
  'shipping.pickCountry': 'Select a highlighted country to see the shipping methods available there.',
  'shipping.shopifyMethodsHead': 'Shopify methods',
  'shipping.methodsLoading': 'Loading methods…',
  'shipping.methodsError': 'Could not load the methods for this country.',
  'shipping.methodsEmpty': 'No shipping methods available for this country.',
  'shipping.methodsEmptyButCovered': 'Your Shopify settings cover this country, but Shopify returned no specific method for it right now.',
  'shipping.methodsEmptyCheckoutHint': 'The exact fee is calculated by Shopify for the buyer’s address at checkout.',
  'shipping.priceAtCheckout': 'Price at checkout',
  'shipping.notConnectedTitle': 'Connect your Shopify store',
  'shipping.notConnectedBody': 'Connect your Shopify store to see the countries and methods you ship with.',
  'shipping.accessDeniedTitle': 'Reconnect your Shopify store',
  'shipping.accessDeniedBody': 'We can’t read your shipping settings — your Shopify connection is missing the shipping permission. Please reconnect the store to grant it.',
  'shipping.genericErrorTitle': 'Shipping unavailable',
  'shipping.genericErrorBody': 'We couldn’t read your shipping settings from Shopify right now. Please try again later.',
  // documents#637 — the store's token was rejected (error: shopify_reauth_required),
  // or the read_shipping scope was never granted (shipping_access_denied +
  // reason: scope_missing:read_shipping).
  'shipping.reauthTitle': 'Reconnect your Shopify store',
  'shipping.reauthBody':
    'The Shopify connection was interrupted — open the Outfino app in your Shopify Admin to reconnect.',
  'shipping.scopeMissingTitle': 'Permission needed to read shipping',
  'shipping.scopeMissingBody':
    'Reading your shipping settings needs a permission — open the Outfino app in your Shopify Admin and accept the requested permission.',
  'shipping.openShopifyApp': 'Open the Outfino app in Shopify',
  // #623 — state of the cached coverage shoppers are filtered on.
  'shipping.statusValid': 'In sync with Shopify — last updated {time}',
  'shipping.statusStale': 'Not updated for {days} days — check your Shopify connection',
  'shipping.statusStaleNoDate': 'Coverage data may be outdated — check your Shopify connection',
  'shipping.statusUnknown': 'Could not read your Shopify shipping settings — open the Outfino app in your Shopify Admin or check its permissions',

  'tab.payouts': 'Payouts',
  'tab.members': 'Members',
  'tab.drops': 'Drops',
  'tab.campaigns': 'Creator campaigns',
  'tab.challenges': 'Challenges',
  'tab.special': 'Advanced',

  // ---- Creator campaigns ----
  'campaigns.title': 'Creator campaigns',
  'campaigns.new': 'New brief',
  'campaigns.empty': 'You haven’t created a brief yet. Start with your first!',
  'campaigns.back': 'Back',
  'campaigns.applicantsCount': '{count} applicants',
  'campaigns.selectedCount': '{done}/{total} selected',
  'campaigns.applicants': 'Applicants',
  'campaigns.noApplicants': 'No one has applied to this brief yet.',
  'campaigns.selected': 'Selected',
  'campaigns.select': 'Select',
  'campaigns.deselect': 'Deselect',
  'campaigns.slots': '{count} creators needed',
  'campaigns.videos': '{count} videos / creator',
  'campaigns.applyDeadline': 'Application deadline',
  'campaigns.deliveryDeadline': 'Delivery deadline',
  'campaigns.status.open': 'Open',
  'campaigns.status.selecting': 'Selecting',
  'campaigns.status.in_progress': 'In progress',
  'campaigns.status.completed': 'Completed',
  'campaigns.newTitle': 'Create a new brief',
  'campaigns.fTitle': 'Title',
  'campaigns.fDescription': 'Description',
  'campaigns.fSlots': 'How many creators?',
  'campaigns.fVideos': 'Videos / creator',
  'campaigns.fPayment': 'Payment',
  'campaigns.fPaymentPh': 'e.g. Reward per approved video + bonus',
  'campaigns.create': 'Create brief',
  'campaigns.creating': 'Creating...',
  'campaigns.cancel': 'Cancel',
  'campaigns.fAmount': 'Amount',
  'campaigns.fAmountPh': 'e.g. 150',
  'campaigns.fCurrency': 'Currency',
  'campaigns.loading': 'Loading campaigns...',
  'campaigns.error': 'Could not load campaigns. Please try again.',

  // ---- Brand profile ----
  'profile.title': 'Brand profile',
  'profile.logo': 'Change logo',
  'profile.cover': 'Change cover',
  'profile.coverHint': 'Add a cover image',
  'profile.name': 'Brand name',
  'profile.company': 'Company name',
  'profile.tagline': 'Tagline',
  'profile.taglineHint': 'One line under your brand name in the app (max 140 characters)',
  'profile.description': 'Description',
  'profile.phone': 'Phone number',
  'profile.website': 'Website',
  'profile.address': 'Address',
  'profile.iban': 'IBAN (for payouts)',
  'profile.visibility': 'Brand is visible in Outfino',
  'profile.save': 'Save changes',
  'profile.saving': 'Saving…',
  'profile.saved': 'Saved.',
  'profile.saveError': 'Could not save. Please try again.',
  'profile.readOnly': 'You don’t have permission to edit this brand.',
  'profile.websiteMoved': 'Set your webshop address on the Settings page, in the Brand profile’s “Webshop address” field.',
  'profile.websiteLink': 'Go there',
  'profile.ibanNeedsBilling': 'The IBAN can be changed by the brand owner or a member with the billing permission.',
  'profile.notStoredYet': 'The server cannot save this field yet.',
  'profile.visibilitySuspended': 'Outfino has suspended your brand, so this switch does not make it visible right now. If you have a question, write to us.',
  'profile.err.iban': 'Invalid IBAN. Check the number (e.g. HU42 1177 3016 1111 1018 0000 0000).',
  'profile.err.ibanPermission': 'Changing the IBAN needs the billing permission.',
  'profile.err.companyName': 'The company name is too long (at most 255 characters).',
  'profile.err.address': 'The address is too long (at most 500 characters).',
  'profile.err.adminOnly': 'Only Outfino can change this field.',

  // ---- Products ----
  'products.title': 'Products',
  'products.empty': 'No products yet. Sync your Shopify catalog to import them.',
  'products.sync': 'Sync products',
  'products.syncing': 'Syncing…',
  'products.syncStarted': 'Sync started — this can take a moment.',
  'products.openInShopify': 'Open in Shopify',
  'products.search': 'Search products',
  'products.noMatch': 'No products match your search.',
  'products.loadError': 'Could not load products.',
  'products.retry': 'Try again',
  'products.soldOut': 'Sold out',
  'products.stockCount': '{n} in stock',
  'products.stockUntracked': 'Stock not tracked',
  'products.stockVariantsOut': '{out} of {total} variants sold out',
  // #615 — sync progress + the products the classifier left out.
  'products.syncProgress': 'Syncing products',
  'products.syncCount': '{done} of {total}',
  'products.syncPreparing': 'Reading your catalogue…',
  // Website crawl ("Fetch products") — for brands that don't sync from Shopify.
  'products.crawl': 'Fetch products',
  'products.crawling': 'Fetching…',
  'products.crawlSoon': 'Coming soon',
  'products.lastCrawl': 'Last fetched: {ago}',
  'products.lastCrawlCount': '· {n} products',
  'products.lastCrawlNever': "You haven't run a product fetch yet",
  'products.crawlPhase.queued': 'Preparing…',
  'products.crawlPhase.discovering': 'Discovering products…',
  'products.crawlPhase.ingesting': 'Importing products…',
  'products.crawlPhase.done': 'Done',
  'products.crawlProgress': 'Found: {found} · imported: {ingested}',
  'products.crawlDone': 'Done — {n} products imported.',
  'products.crawlError.NO_PRODUCTS': 'We found no products at this address.',
  'products.crawlError.DOMAIN_NOT_SET': 'Set your webshop address first.',
  'products.crawlError.CRAWL_FAILED': 'The fetch failed. Please try again later.',
  'products.crawlSetDomain': 'Set up',
  'products.emptyCrawl':
    'No products yet. Click “Fetch products” to import the products from your webshop.',
  'products.excludedTitle': 'Not recognised as clothing',
  'products.excludedHint':
    'These products synced, but the classifier did not recognise them as clothing, so they do not appear to shoppers on Outfino.',
  // documents#188 — per-product AI labelling status (ai_labeling on the list).
  'products.labelPending': 'Labelling in progress…',
  'products.labelDone': 'Labelled',
  'products.labelDoneCategory': 'Labelled: {category}',
  'products.labelFailed': 'Labelling failed',
  'products.labelSkipped': 'Cannot be labelled',
  'products.labelRetry': 'Retry',
  'products.labelRetrying': 'Queuing…',
  'products.labelNotLabelable': 'This product cannot be labelled (deleted or has no Shopify data).',
  'products.labelRetryFailed': 'Could not queue the labelling. Try again.',
  'products.disputeAction': 'Wrong classification?',
  'products.disputeTitle': 'Report wrong classification',
  'products.disputeVerdictNotClothing': 'AI says: not clothing',
  'products.disputeAskClothing': 'You are asking for a review to mark this product as clothing.',
  'products.disputeMessage': 'Message (optional)',
  'products.disputeMessageHint': 'Why do you think the classification is wrong?',
  'products.disputeSubmit': 'Request review',
  'products.disputeSending': 'Sending…',
  'products.disputeCancel': 'Cancel',
  'products.disputePending': 'Review pending',
  'products.disputeRejected': 'Request rejected',
  'products.disputeSentOn': 'Sent on {date}',
  'products.disputeApprovedAs': 'Now listed as clothing',
  'products.disputeApprovedAsCategory': 'Now listed as clothing · {category}',
  'products.disputeNoReason': 'The admin gave no reason.',
  'products.disputeAgain': 'Ask again',
  'products.disputeApproved': 'Request approved',
  'products.disputeNotDisputable': 'This product cannot be disputed right now (deleted, or still being labelled).',
  'products.disputeFailed': 'Could not send the request. Try again.',

  // ---- Drops ----
  'drops.title': 'Drops',
  'drops.empty': 'No drops yet',
  'drops.status.scheduled': 'Scheduled',
  'drops.status.active': 'Active',
  'drops.status.completed': 'Completed',
  'drops.status.cancelled': 'Cancelled',
  'drops.new': 'New drop',
  'drops.cancelFailed': 'Could not delete the drop. Try again.',
  'drops.form.title': 'New drop',
  'drops.form.date': 'Time',
  'drops.form.create': 'Schedule drop',
  'drops.form.noDate': 'No date yet',
  'drops.form.close': 'Close',
  'drops.form.creating': 'Scheduling…',
  'drops.form.failed': 'Could not schedule the drop. Try again.',

  // ---- Stats ----
  'stats.title': 'Statistics',
  'stats.available': 'Available balance',
  'stats.totalEarned': 'Total earned',
  'stats.thisMonth': 'This month',
  'stats.orders': 'Orders',
  'stats.revenue': 'Revenue',
  'stats.payouts': 'Payouts',
  'stats.noPayouts': 'No payouts yet.',
  'stats.period.day': 'Day',
  'stats.period.week': 'Week',
  'stats.period.month': 'Month',
  'stats.period.year': 'Year',
  'stats.period.all': 'All time',

  // ---- Payouts ----
  'payouts.title': 'Payouts',
  'payouts.request': 'Request payout',
  'payouts.requesting': 'Requesting…',
  'payouts.requested': 'Payout request sent.',
  'payouts.requestError': 'Could not send the request. Please try again.',
  'payouts.pending': 'Pending',
  'payouts.history': 'Payout history',
  'payouts.commissionNote': 'after {pct}% Outfino commission',
  'payouts.breakdownTitle': 'Revenue breakdown',
  'payouts.gross': 'Gross revenue',
  'payouts.commissionLine': 'Outfino commission ({pct}%)',
  'payouts.net': 'Net — yours',

  // ---- Members ----
  'members.title': 'Members',
  'members.empty': 'No members yet.',
  'members.anonymous': 'Anonymous',
  'members.role.owner': 'Owner',
  'members.role.member': 'Member',
  'members.add': 'Add member',
  'members.devLocked': 'Development brands cannot take on new members.',
  'members.searchPlaceholder': 'Search by username…',
  'members.searchEmpty': 'No matches.',
  'members.remove': 'Remove',

  // ---- Permissions ----
  'perm.viewProducts': 'View products',
  'perm.editProducts': 'Edit products',
  'perm.viewOrders': 'View orders',
  'perm.viewAnalytics': 'View analytics',
  'perm.manageMembers': 'Manage members',
  'perm.manageCampaigns': 'Manage campaigns',
  'perm.editBrand': 'Edit brand',
  'perm.manageBilling': 'Manage billing',

  // ---- Danger zone (delete brand) ----
  'danger.title': 'Danger zone',
  'danger.deleteBrand': 'Remove this brand',
  'danger.deleteBody': 'Outfino is uninstalled from your Shopify store, your products disappear from Outfino, and every member, you included, is removed from the brand. Whoever connects the store next becomes its new owner. This cannot be undone.',
  'danger.confirm': 'Are you sure you want to remove {name}? This cannot be undone.',
  'danger.error': 'Could not remove the brand. Please try again.',
  'danger.deleting': 'Removing…',
  // ---- Challenges / galaxy gift drops (GiftDropsTab) ----
  'gifts.title': 'Gift chest in the galaxy',
  'gifts.lead': 'Drop a chest into the Outfino app’s Style Universe galaxy. It drifts in from beyond the rim, crosses the galaxy in about 100 seconds, and the first person to tap it takes it. If nobody catches it, it drifts out.',
  'gifts.dropButton': 'Drop a gift into the galaxy',
  'gifts.dropped': 'Your chest is on its way into the galaxy.',
  'gifts.cancelled': 'The chest has been withdrawn.',
  'gifts.activeTitle': 'Active chests',
  'gifts.polling': 'Refreshing every {s} s',
  'gifts.pollingTitle': 'The page refreshes by itself — more often while a chest is in the galaxy.',
  'gifts.live': 'Live',
  'gifts.liveTitle': 'Live connection: changes show up at once.',
  'gifts.err.brandInactive': 'Your brand is not visible on Outfino right now, so it cannot drop chests.',
  'gifts.err.notEligible': 'This brand cannot drop chests into the galaxy right now.',
  'gifts.err.followersOnly': 'Only the brand\'s followers can catch this chest.',
  'gifts.err.brandNotFound': 'This brand could not be found.',
  'gifts.followersOnly': 'Followers only',
  'gifts.followersOnlyTitle': 'Only your brand\'s followers can catch it; everyone else sees it chained shut.',
  'gifts.modal.followersOnly': 'Followers only',
  'gifts.modal.followersOnlyHint': 'People who don\'t follow the brand see the chest chained shut and cannot catch it.',
  'gifts.retry': 'Retry',
  'gifts.noActive': 'You have no chest in the galaxy right now.',
  'gifts.historyTitle': 'History',
  'gifts.noHistory': 'You haven’t dropped a chest yet.',
  'gifts.loadMore': 'Load more',
  'gifts.someone': 'Someone',
  'gifts.seconds': '{n} s',
  'gifts.cancel': 'Withdraw',
  'gifts.cancelTitle': 'Withdraw this chest?',
  'gifts.cancelText': 'The chest dropped at {at} disappears from the galaxy at once, and nobody can catch it. This cannot be undone.',
  'gifts.cancelling': 'Withdrawing…',
  'gifts.cancelConfirm': 'Yes, withdraw it',
  'gifts.phase.incoming': 'drifting into the galaxy',
  'gifts.phase.inside': 'to the rim',
  'gifts.phase.leaving': 'drifting out of the galaxy',
  'gifts.status.active': 'Active',
  'gifts.status.collected': 'Caught',
  'gifts.status.expired': 'Drifted out',
  'gifts.status.cancelled': 'Withdrawn',
  'gifts.col.createdAt': 'Created',
  'gifts.col.status': 'Status',
  'gifts.col.winner': 'Winner',
  'gifts.col.reaction': 'Reaction time',
  'gifts.col.crossing': 'Crossing',
  'gifts.modal.title': 'Drop a gift into the galaxy',
  'gifts.modal.logoTitle': 'Your logo is on the chest',
  'gifts.modal.logoText': 'Everyone watching the galaxy in the app sees it.',
  'gifts.modal.text': 'The chest drifts in from beyond the galaxy’s rim, crosses it rim to rim in about 100 seconds, and the first person to tap it in the Outfino app takes it. If nobody catches it, it drifts out.',
  'gifts.modal.reward': 'Gift',
  'gifts.modal.rewardSoon': 'Gift (coupon) — coming soon',
  'gifts.modal.rewardHint': 'Soon you can put a coupon in the chest. Until then it drifts without a gift.',
  'gifts.modal.note': 'Note (optional)',
  'gifts.modal.notePlaceholder': 'E.g. autumn campaign — only your team sees it',
  'gifts.modal.back': 'Cancel',
  'gifts.modal.dropping': 'Dropping…',
  'gifts.modal.confirm': 'Drop it',
  'gifts.err.galaxyFull': 'There are too many chests in the galaxy right now. Try again in a few minutes.',
  'gifts.err.notActive': 'This chest is no longer in the galaxy.',
  'gifts.err.notActiveStatus': 'This chest is no longer in the galaxy ({status}).',
  'gifts.err.notFound': 'This chest could not be found.',
  'gifts.err.invalid': 'Something in the form is not valid. Check the note and try again.',
  'gifts.err.disabled': 'Dropping chests is not available right now.',
  'gifts.err.forbidden': 'You don’t have permission to drop chests for this brand.',
  'gifts.err.auth': 'Your session has expired. Please log in again.',
  'gifts.err.rateLimited': 'Too many requests at once. Wait a moment and try again.',
  'gifts.err.network': 'We can’t reach the server. Check your connection and try again.',
  'gifts.err.unavailable': 'This feature is not available here yet.',
  'gifts.err.genericCode': 'Something went wrong ({code}). Please try again.',
  'gifts.err.generic': 'Something went wrong. Please try again.',
  'gifts.modal.prize': 'Prize (optional)',
  'gifts.modal.prizeHint': 'Whoever catches the chest gets these products of yours free in their cart (1 of each, up to {max} products).',
  'gifts.modal.prizeAdd': 'Add a product',
  'gifts.prize.label': 'Prize',
  'gifts.prize.none': 'No prize',
  'gifts.prize.freeShip': 'free shipping',
  'gifts.col.prize': 'Prize',
  'gifts.err.freeShipping': 'To drop a chest with products, accept that shipping is free (you cover its cost).',
  'gifts.err.product.product_not_found': 'One of the products could not be found. Pick the products again.',
  'gifts.err.product.product_inactive': 'One of the products is not active, so it can\'t be a prize.',
  'gifts.err.product.product_out_of_stock': 'One of the products is out of stock, so it can\'t be a prize.',
  'gifts.err.product.duplicate_product': 'The same product is in there twice.',
  'gifts.err.product.too_many_products': 'A chest can hold 5 products at most.',
  // ---- Challenges: prize wheel (Szerencsekerék) + the game switcher ----
  'games.label': 'Games',
  'games.gifts.title': 'Gift chest',
  'games.gifts.text': 'Crosses the galaxy — the first tap takes it',
  'games.wheel.title': 'Prize wheel',
  'games.wheel.text': 'Next to your store, drawn live',
  'wheel.title': 'Prize wheel',
  'wheel.lead': 'Schedule a giveaway of your products: the wheel stands next to your store on the Outfino map, people join it in the app, and you start the draw live — fairly and verifiably.',
  'wheel.scheduleButton': 'Schedule a prize wheel',
  'wheel.oneAtATime': 'You can have one active prize wheel at a time. You can schedule a new one once this one is drawn or cancelled.',
  'wheel.scheduled': 'Scheduled! The wheel now stands next to your store on the map.',
  'wheel.updated': 'Your changes are saved.',
  'wheel.cancelled': 'The prize wheel has been cancelled.',
  'wheel.currentTitle': 'Current wheel',
  'wheel.pollingTitle': 'The page refreshes by itself — more often while the wheel is scheduled or spinning.',
  'wheel.noActive': 'You have no prize wheel on the map right now.',
  'wheel.historyTitle': 'Past wheels',
  'wheel.noHistory': 'No past prize wheels yet.',
  'wheel.status.scheduled': 'Scheduled',
  'wheel.status.drawing': 'Drawing now',
  'wheel.status.finished': 'Finished',
  'wheel.status.cancelled': 'Cancelled',
  'wheel.opensAtChip': 'Joining opens {at}',
  'wheel.joinOpen': 'Joining open',
  'wheel.edit': 'Edit',
  'wheel.cancel': 'Cancel wheel',
  'wheel.stat.untilDraw': 'Until the draw',
  'wheel.stat.spinEnds': 'Draw ends in',
  'wheel.stat.drawnAt': 'Drawn',
  'wheel.stat.participants': 'Participants',
  'wheel.stat.winners': 'Winners',
  'wheel.stat.opensIn': 'Joining opens in',
  'wheel.drawingNow': 'The wheel is spinning in the app right now.',
  'wheel.countdownDays': '{d} d {hms}',
  'wheel.lock.joined': 'People have already joined, so it can no longer be edited — you can still cancel it.',
  'wheel.lock.soon': 'It can\'t be edited in the last 10 minutes before the draw.',
  'wheel.lock.generic': 'This wheel can no longer be edited.',
  'wheel.winnersTitle': 'Winners',
  'wheel.winnersError': 'Couldn\'t load the winners right now.',
  'wheel.noParticipants': 'Nobody joined, so there was no winner.',
  'wheel.noWinners': 'No winners.',
  'wheel.noWinnersShort': 'None',
  'wheel.winnersN': '{n} winners',
  'wheel.someone': 'Someone',
  'wheel.anonymous': 'private profile',
  'wheel.round': 'Round {n}',
  'wheel.entryIndexTitle': 'The winning point\'s number on the wheel (from 0)',
  'wheel.details': 'Details',
  'wheel.cancelledAt': 'Cancelled on {at}. There was no draw.',
  'wheel.proof.title': 'Verifiable draw',
  'wheel.proof.seedHash': 'Fingerprint (seed hash)',
  'wheel.proof.seed': 'Secret key (seed)',
  'wheel.proof.seedHidden': 'Revealed after the draw',
  'wheel.proof.textScheduled': 'The fingerprint was fixed when the wheel was scheduled; its secret key is published after the draw, so nobody can bend the result afterwards.',
  'wheel.proof.textFinished': 'The secret key is public now: anyone can check that its fingerprint matches and that it gives the same winners.',
  'wheel.proof.check': 'Verify now',
  'wheel.proof.checking': 'Verifying…',
  'wheel.proof.ok': 'Verified: the fingerprint and the winners both match.',
  'wheel.proof.okHash': 'The fingerprint matches.',
  'wheel.proof.badHash': 'The fingerprint does not match the key.',
  'wheel.proof.badWinners': 'The key gives different winners.',
  'wheel.proof.checkError': 'We can\'t verify it in this browser right now.',
  'wheel.proof.copy': 'Copy {what}',
  'wheel.proof.howTitle': 'How to verify it',
  'wheel.proof.how1': 'When the wheel is scheduled, the server picks a random 32-byte key and publishes only its SHA-256 fingerprint.',
  'wheel.proof.how2': 'At the draw, the participants are numbered from 0 in the order they joined.',
  'wheel.proof.how3': 'Each round\'s winner number comes from this (an unbiased pick, earlier winners excluded):',
  'wheel.proof.how3Code': 'HMAC-SHA256(key, "{id}:<round>:<attempt>")',
  'wheel.cancelTitle': 'Cancel this prize wheel?',
  'wheel.cancelText': 'The wheel “{title}” disappears from the map at once, and the draw planned for {at} will not happen. This cannot be undone.',
  'wheel.cancelJoined': '{n} people have already joined.',
  'wheel.cancelling': 'Cancelling…',
  'wheel.cancelConfirm': 'Yes, cancel it',
  'wheel.form.createTitle': 'Schedule a prize wheel',
  'wheel.form.editTitle': 'Edit the prize wheel',
  'wheel.form.back': 'Cancel',
  'wheel.form.title': 'Title',
  'wheel.form.titlePlaceholder': 'E.g. Autumn collection giveaway',
  'wheel.form.titlePreview': 'Your wheel\'s title',
  'wheel.form.prize': 'Prize',
  'wheel.form.prizePlaceholder': 'E.g. one bag from the autumn collection, shipped free',
  'wheel.form.winners': 'Number of winners',
  'wheel.form.winnersHint': '1–{max} winners, drawn one after another.',
  'wheel.form.winnersLocked': 'Can\'t be changed after scheduling.',
  'wheel.form.less': 'Fewer',
  'wheel.form.more': 'More',
  'wheel.form.opens': 'Joining opens',
  'wheel.form.opensNow': 'Right away',
  'wheel.form.opensLater': 'Later',
  'wheel.form.opensDate': 'Opening date',
  'wheel.form.opensTime': 'Opening time',
  'wheel.form.draw': 'Draw time',
  'wheel.form.drawDate': 'Draw date',
  'wheel.form.drawTime': 'Draw time of day',
  'wheel.form.quick.inHour': 'In 1 hour',
  'wheel.form.quick.tomorrow': 'Tomorrow 20:00',
  'wheel.form.quick.week': 'In a week, 20:00',
  'wheel.form.drawHint': 'At least 10 minutes after joining opens, at most 30 days ahead.',
  'wheel.form.rules': 'I accept the game rules',
  'wheel.form.rulesHint': 'The draw follows Outfino\'s game rules; accept them to schedule the wheel.',
  'wheel.form.schedule': 'Schedule',
  'wheel.form.scheduling': 'Scheduling…',
  'wheel.form.save': 'Save',
  'wheel.form.saving': 'Saving…',
  'wheel.form.fix': 'Check the fields marked in red.',
  'wheel.form.err.titleRequired': 'Give the wheel a title.',
  'wheel.form.err.titleTooLong': '80 characters at most.',
  'wheel.form.err.prizeRequired': 'Describe what can be won.',
  'wheel.form.err.prizeTooLong': '500 characters at most.',
  'wheel.form.err.winners': 'A number from 1 to 10.',
  'wheel.form.err.opensRequired': 'Set when joining opens.',
  'wheel.form.err.drawRequired': 'Set the draw date and time.',
  'wheel.form.err.drawTooSoon': 'The draw must be at least 10 minutes after joining opens.',
  'wheel.form.err.drawTooLate': 'You can schedule at most 30 days ahead.',
  'wheel.form.err.rules': 'Accept the game rules to schedule.',
  'wheel.form.err.server': 'The server didn\'t accept this field.',
  'wheel.how.mapTitle': 'On the map.',
  'wheel.how.map': 'Once scheduled, the wheel appears next to your store on the Outfino map.',
  'wheel.how.joinTitle': 'Joining in the app.',
  'wheel.how.join': 'People join in the app, from the opening until the draw — everyone or only your followers, as you set it.',
  'wheel.how.drawTitle': 'A live draw.',
  'wheel.how.draw': 'At the draw time you start the wheel (even on a livestream); the result can be verified.',
  'wheel.preview.countLabel': 'participants',
  'wheel.preview.label': '{name} prize wheel in 3D',
  'wheel.preview.hint': 'Drag to turn',
  'wheel.preview.spin': 'Test spin',
  'wheel.preview.spinning': 'Spinning…',
  'wheel.preview.noGl': 'The 3D preview needs WebGL.',
  'wheel.preview.error': 'Couldn\'t load the preview right now.',
  'wheel.preview.drawChip': 'Draw: {at}',
  'wheel.preview.caption': 'Preview in your brand\'s colours. The dots are the people who joined ({n} here, as an example).',
  'wheel.col.drawAt': 'Draw',
  'wheel.col.wheel': 'Wheel',
  'wheel.col.status': 'Status',
  'wheel.col.participants': 'Participants',
  'wheel.col.winners': 'Winners',
  'wheel.col.details': 'Details',
  'wheel.err.activeExists': 'You can only have one active prize wheel at a time. Let the current one be drawn, or cancel it, and then schedule a new one.',
  'wheel.err.locked': 'This wheel can no longer be edited: people have joined, or the draw is close.',
  'wheel.err.notCancellable': 'This wheel can no longer be cancelled — the draw has started or finished.',
  'wheel.err.notFound': 'This prize wheel could not be found.',
  'wheel.err.invalid': 'Something in the form is not valid. Check it and try again.',
  'wheel.err.invalidField': 'The server did not accept this field: {field}.',
  'wheel.err.brandInactive': 'Your brand is not visible on Outfino right now, so it cannot schedule a prize wheel.',
  'wheel.err.notEligible': 'This brand cannot schedule a prize wheel right now.',
  'wheel.err.disabled': 'Prize wheels are not available right now.',
  'wheel.err.forbidden': 'You don’t have permission to manage prize wheels for this brand.',
  'wheel.err.brandNotFound': 'This brand could not be found.',
  'wheel.err.auth': 'Your session has expired. Please log in again.',
  'wheel.err.rateLimited': 'Too many requests at once. Wait a moment and try again.',
  'wheel.err.network': 'We can’t reach the server. Check your connection and try again.',
  'wheel.err.unavailable': 'This feature is not available here yet.',
  'wheel.err.genericCode': 'Something went wrong ({code}). Please try again.',
  'wheel.err.generic': 'Something went wrong. Please try again.',
  'wheel.free.accept': 'I understand: the winner gets the product and the shipping free, and I cover the shipping cost.',
  'wheel.form.err.freeShipping': 'Accept the free shipping to schedule.',
  'wheel.form.err.roundTooMany': 'A round can hold at most 5 different products.',
  'wheel.form.productOut': 'Unavailable',
  'wheel.err.rounds.product_not_found': 'A product in round {round} could not be found.',
  'wheel.err.rounds.product_inactive': 'A product in round {round} is not active.',
  'wheel.err.rounds.product_out_of_stock': 'A product in round {round} is out of stock.',
  'wheel.err.rounds.duplicate_product': 'Round {round} has the same product twice.',
  'wheel.err.rounds.too_many_products': 'Round {round} has too many products (5 at most).',
  'wheel.err.rounds.empty_round': 'Round {round} is empty.',
  'wheel.err.rounds.too_many_rounds': 'There can be 10 rounds at most.',
  'wheel.status.ready': 'Ready to draw',
  'wheel.free.title': 'Free prize, free shipping.',
  'wheel.free.text': 'The winner gets the product(s) free in their cart, and shipping is mandatorily free too — you cover the shipping cost.',
  'wheel.form.rounds': 'Prizes, round by round',
  'wheel.form.roundsHint': 'Each round is one spin and one winner, who gets all of the round\'s products (1 of each, up to 5 products a round). Up to 10 rounds. Only active, in-stock products can be prizes.',
  'wheel.form.roundAdd': 'Add a round',
  'wheel.form.roundUp': 'Move round {n} up',
  'wheel.form.roundDown': 'Move round {n} down',
  'wheel.form.roundRemove': 'Remove round {n}',
  'wheel.form.roundEmptyHint': 'No products yet',
  'wheel.form.productsN': '{n} products',
  'wheel.form.productsAdd': 'Add products',
  'wheel.form.productsEdit': 'Change products',
  'wheel.form.productSearch': 'Search your products',
  'wheel.form.productsPicked': '{n}/{max} selected',
  'wheel.form.productsDone': 'Done',
  'wheel.form.productsNone': 'You have no products on Outfino yet. Sync them on the Products page.',
  'wheel.form.productsNoMatch': 'No product matches.',
  'wheel.form.productsError': 'Couldn\'t load your products right now.',
  'wheel.form.productRemove': 'Remove {name}',
  'wheel.form.exclude': 'Someone who won an earlier round can\'t win again',
  'wheel.form.excludeHint': 'So every round gets a different winner.',
  'wheel.form.prizeOptional': 'Description (optional)',
  'wheel.form.prizeAutoHint': 'Leave it empty and we build it from the products.',
  'wheel.form.autoSummaryRound': 'Round {n}: {names}',
  'wheel.form.eligibility': 'Who can join?',
  'wheel.eligibility.followers_at_schedule': 'Current followers only',
  'wheel.eligibility.followers_at_scheduleHint': 'People who follow you now; new followers excluded.',
  'wheel.eligibility.followers': 'Followers',
  'wheel.eligibility.followersHint': 'New followers can join too.',
  'wheel.eligibility.everyone': 'Everyone',
  'wheel.eligibility.everyoneHint': 'Anyone can join, follower or not.',
  'wheel.excludeOn': 'One win per person',
  'wheel.excludeOff': 'Repeat wins allowed',
  'wheel.form.err.roundsCount': 'Add 1 to 10 rounds.',
  'wheel.form.err.roundEmpty': 'Put at least one product in every round.',
  'wheel.form.err.eligibility': 'Choose who can join.',
  'wheel.preview.roundsChip': '{n} rounds',
  'wheel.stat.rounds': 'Rounds',
  'wheel.stat.autoStart': 'Starts by itself in',
  'wheel.readyNow': 'Joining has closed — start the draw!',
  'wheel.prizesTitle': 'Prizes',
  'wheel.resultsTitle': 'Results by round',
  'wheel.noWinnerRound': 'No winner',
  'wheel.live.ready': 'Ready to draw',
  'wheel.live.start': 'Start the draw',
  'wheel.live.starting': 'Starting…',
  'wheel.live.waiting': 'The brand starts the draw.',
  'wheel.live.auto': 'If you don\'t start it within 30 s, it starts by itself ({s} s).',
  'wheel.live.startsIn': 'Starting in {s} s',
  'wheel.live.spinning': 'Round {n} / {total} — spinning',
  'wheel.live.roundWinner': 'Round {n} winner',
  'wheel.live.done': 'The draw is over',
  'wheel.live.fullscreen': 'Full screen',
  'wheel.live.exitFullscreen': 'Exit full screen',
  'wheel.err.notReady': 'The draw can\'t be started yet.',
  'wheel.err.alreadyDrawn': 'The draw has already started.',
  'wheel.err.products': 'One of the products can\'t be a prize. Check the rounds.',
  'wheel.err.socket': 'No live connection to the server. Try again — if you don\'t, it starts by itself after 30 s.',
  // ---- Dev banner ----
  'dev.bannerFull': 'Development mode — visit the live version here: ',
  'dev.bannerShort': 'Development mode — ',
  'dev.userBannerFull': 'Development mode — you are signed in as a dev user',
  'dev.userBannerShort': 'Dev user',

  'tab.discounts': "Discounts",
  'discounts.title': "Discounts",
  'discounts.subtitle': "Automatic discounts and coupon codes for Outfino shoppers. Everything is created in and kept in sync with your Shopify store.",
  'discounts.new': "New discount",
  'discounts.section.automatic': "Automatic discounts",
  'discounts.section.code': "Coupons",
  'discounts.empty.automatic': "No automatic discounts yet.",
  'discounts.empty.code': "No coupons yet. Create a code shoppers can enter in their cart.",
  'discounts.sync': "Sync with Shopify",
  'discounts.syncing': "Syncing…",
  'discounts.synced': "Discounts are in sync with Shopify.",
  'discounts.created': "{code} created in Shopify and Outfino.",
  'discounts.pause': "Pause",
  'discounts.resume': "Resume",
  'discounts.delete': "Delete",
  'discounts.confirmDelete': "Delete {code}? It's removed from your Shopify store too.",
  'discounts.usage': "Used {used}×",
  'discounts.usageOf': "Used {used} / {limit}",
  'discounts.minSubtotal': "Over {amount}",
  'discounts.minQuantity': "From {n} items",
  'discounts.allProducts': "All products",
  'discounts.productCount': "{n} products",
  'discounts.oncePerCustomer': "Once per customer",
  'discounts.fromShopify': "From Shopify",
  'discounts.method.automatic': "Automatic discount",
  'discounts.method.code': "Coupon code",
  'discounts.status.active': "Active",
  'discounts.status.scheduled': "Scheduled",
  'discounts.status.paused': "Paused",
  'discounts.status.expired': "Expired",
  'discounts.status.used_up': "Used up",
  'discounts.form.titleCoupon': "New coupon",
  'discounts.form.kind': "Kind",
  'discounts.form.shopify': "Shopify",
  'discounts.form.shopifySync': "Sync to Shopify",
  'discounts.form.shopifyLocal': "Outfino only",
  'discounts.form.localNote': "The discount only works on Outfino and isn't created in your Shopify store. You still pay for it from your payout.",
  'discounts.syncedShopify': "Synced to Shopify",
  'discounts.outfinoOnly': "Outfino only",
  'discounts.createdLocal': "{code} created on Outfino.",
  'discounts.confirmDeleteLocal': "Delete {code}?",
  'discounts.currency': "Store currency: {currency}",
  'discounts.form.title': "New discount",
  'discounts.form.close': "Close",
  'discounts.form.methodHint.automatic': "Applied automatically at checkout when the conditions are met — shoppers don't need a code.",
  'discounts.form.methodHint.code': "Shoppers enter the code in their cart.",
  'discounts.form.code': "Code",
  'discounts.form.codeHint': "3–32 characters: letters, numbers, - and _",
  'discounts.form.name': "Name",
  'discounts.form.nameHint': "Shown to shoppers in the cart",
  'discounts.form.namePlaceholder': "e.g. Autumn sale",
  'discounts.form.type': "Type",
  'discounts.form.typePercentage': "Percentage",
  'discounts.form.typeFixed': "Fixed amount",
  'discounts.form.valuePercent': "Discount (%)",
  'discounts.form.valueAmount': "Discount amount ({currency})",
  'discounts.form.products': "Products",
  'discounts.form.allProducts': "All products",
  'discounts.form.searchProducts': "Search your products…",
  'discounts.form.noProducts': "No products yet.",
  'discounts.form.selected': "{n} selected",
  'discounts.form.condition': "Condition",
  'discounts.form.conditionNone': "None",
  'discounts.form.conditionSubtotal': "Minimum amount",
  'discounts.form.conditionQuantity': "Minimum items",
  'discounts.form.minSubtotal': "Minimum purchase ({currency})",
  'discounts.form.minQuantity': "Minimum number of items",
  'discounts.form.usageLimit': "Total uses",
  'discounts.form.optional': "Optional",
  'discounts.form.startsAt': "Starts",
  'discounts.form.startsHint': "Empty = right away",
  'discounts.form.endsAt': "Ends",
  'discounts.form.oncePerCustomer': "One use per customer",
  'discounts.form.shopifyNote': "The discount is created in your Shopify store as well, and you pay for it from your payout.",
  'discounts.form.cancel': "Cancel",
  'discounts.form.create': "Create",
  'discounts.form.creating': "Creating…",
  'discounts.error.taken': "This code already exists.",
  'discounts.error.invalid': "Shopify refused the discount. Check the values and try again.",
  'discounts.error.reauth': "Outfino needs permission to manage discounts in your Shopify store. Open the Outfino app in Shopify and approve the updated permissions.",
  'discounts.error.createFailed': "Could not create the discount. Try again.",
  'discounts.error.syncFailed': "Could not sync with Shopify. Try again.",
  'discounts.error.updateFailed': "Could not update the discount. Try again.",
  'discounts.error.deleteFailed': "Could not delete the discount. Try again.",

  // ── Fit-check embed (Statistics / Visitors / Settings) ──
  'tab.embedded-settings': 'Settings',
  'embed.range.label': 'Period',
  'embed.range.days': '{n} days',
  'embed.range.custom': 'Custom',
  'embed.range.from': 'From',
  'embed.range.to': 'To',
  'embed.mock.badge': 'Test data',
  'embed.mock.title': 'This is test data, not real traffic.',
  'embed.error.load': 'Could not load the data. Try again with the Refresh button.',
  'embed.error.forbidden': "You don't have access to this page for this brand.",
  'embed.empty.range': 'No data for this period yet.',
  'embed.copy.button': 'Copy',
  'embed.copy.codeDone': 'Embed code copied to the clipboard',
  'embed.copy.failed': 'Copying failed. Select the code and copy it by hand.',

  'embed.stats.title': 'Fit-check button statistics',
  'embed.stats.lead': 'What the "See if it suits you" button did on your product pages: how many people saw it, clicked, signed in, uploaded photos and opened the product matching.',
  'embed.kpi.impressions': 'Impressions',
  'embed.kpi.clicks': 'Clicks',
  'embed.kpi.signups': 'Sign-ups',
  'embed.kpi.logins': 'Logins',
  'embed.kpi.matchViews': 'Matching views',
  'embed.kpi.uploadSessions': 'Uploads',
  'embed.kpi.photosUploaded': 'Photos uploaded',
  'embed.kpi.uniqueVisitors': 'Unique visitors',
  'embed.kpi.ctr': 'Click-through: {pct}',
  'embed.kpi.perUpload': '{n} photos per upload on average',
  'embed.funnel.title': 'Funnel',
  'embed.funnel.impressions': 'Impression',
  'embed.funnel.clicks': 'Click',
  'embed.funnel.signIns': 'Sign-up or login',
  'embed.funnel.matchViews': 'Product matching view',
  'embed.funnel.conv': '{pct} of the previous step',
  'embed.funnel.signInsHint': '{signups} new · {logins} returning',
  'embed.funnel.uploadSessions': 'uploads',
  'embed.funnel.photos': 'photos uploaded',
  'embed.funnel.uploadRate': 'of signed-in visitors uploaded photos',
  'embed.chart.title': 'Daily trend',
  'embed.chart.metricLabel': 'Metric',
  'embed.chart.metric.impressions': 'Impressions',
  'embed.chart.metric.clicks': 'Clicks',
  'embed.chart.metric.signIns': 'Sign-ups + logins',
  'embed.chart.metric.matchViews': 'Matching views',
  'embed.chart.metric.photosUploaded': 'Photos uploaded',
  'embed.chart.showTable': 'Daily breakdown as a table',
  'embed.chart.hideTable': 'Hide table',
  'embed.chart.date': 'Day',
  'embed.top.title': 'Products',
  'embed.top.lead': 'Which product page brought the sign-ups, matching views and uploaded photos, and how well the products suited the visitors.',
  'embed.top.product': 'Product',
  'embed.top.col.impressions': 'Impressions',
  'embed.top.col.clicks': 'Clicks',
  'embed.top.col.signups': 'Sign-ups',
  'embed.top.col.matchViews': 'Matching',
  'embed.top.col.photosUploaded': 'Photos',
  'embed.top.col.avgCompatibility': 'Avg. compatibility',

  'embed.visitors.title': 'Visitors',
  'embed.visitors.lead': 'Who did what with the button, at which of your products. Only signed-in Outfino users are listed here; anonymous carts and purchases show in the Statistics totals.',
  'embed.visitors.product': 'Product',
  'embed.visitors.allProducts': 'All products',
  'embed.visitors.event': 'Event',
  'embed.visitors.allEvents': 'All events',
  'embed.visitors.empty': 'No visitors match these filters in this period.',
  'embed.visitors.shown': '{n} events',
  'embed.visitors.more': 'Load more',
  'embed.visitors.col.user': 'User',
  'embed.visitors.col.event': 'Event',
  'embed.visitors.col.product': 'Product',
  'embed.visitors.col.photos': 'Photos',
  'embed.visitors.col.compat': 'Compatibility',
  'embed.visitors.col.time': 'Time',
  'embed.event.signup': 'Signed up for Outfino',
  'embed.event.login': 'Logged in',
  'embed.event.match_view': 'Viewed the product matching',
  'embed.event.uploadOne': 'Uploaded 1 photo',
  'embed.event.upload': 'Uploaded {n} photos',
  'embed.eventFilter.signup': 'Sign-up',
  'embed.eventFilter.login': 'Login',
  'embed.eventFilter.upload': 'Photo upload',
  'embed.eventFilter.match_view': 'Product matching view',

  'embed.settings.title': 'Fit-check button settings',
  'embed.status.configured': 'Set up',
  'embed.status.notConfigured': 'Not set up',
  'embed.status.lastSeen': 'Last seen on a live page: {ago}',
  'embed.status.notConfiguredHint': "We haven't seen the button on a live page in the last 7 days. Add it with the code below and it shows up here within minutes.",
  'embed.status.domainMeta': '{ago} · {n} impressions in the last 7 days',
  'embed.key.label': 'Embed key',
  'embed.key.masked': 'Embed key, partly hidden',
  'embed.key.copyCode': 'Copy embed code',
  'embed.key.allowed': 'The key only works here: {domains}',
  'embed.design.title': 'Button design',
  'embed.design.lead': "Pick the one that suits your store's theme. The previews show the live button.",
  'embed.design.gallery': 'Shape and colour',
  'embed.design.shape.pill': 'Pill',
  'embed.design.shape.rounded': 'Rounded',
  'embed.design.shape.square': 'Square',
  'embed.design.theme.dark': 'Dark button',
  'embed.design.theme.light': 'Light button',
  'embed.design.variant': 'Width',
  'embed.design.variant.compact': 'Compact',
  'embed.design.variant.full': 'Full width',
  'embed.design.height': 'Height',
  'embed.design.lang': 'Language',
  'embed.design.lang.auto': 'Automatic (recommended)',
  'embed.design.langNote': "The button shows in the visitor's language automatically: Hungarian in a Hungarian browser, English everywhere else. This is the default in the copied code (lang=auto).",
  'embed.design.langForced': 'Every visitor sees the button in {lang}. With the automatic setting everyone sees it in their own language.',
  'embed.design.preview': 'Preview',
  'embed.design.visitor.hu': 'Hungarian visitor',
  'embed.design.visitor.en': 'Visitor in any other language',
  'embed.install.title': 'Add it to your store',
  'embed.install.platform': 'Platform',
  'embed.install.shopify': 'Shopify (Liquid)',
  'embed.install.html': 'Other webshop (HTML)',
  'embed.install.code': 'Embed code',
  'embed.install.liquid.title': 'Custom Liquid block',
  'embed.install.liquid.lead': 'Works in any Shopify theme, by pasting.',
  'embed.install.liquid.step1': 'In the Shopify admin: Online Store → Customize → Product page.',
  'embed.install.liquid.step2': 'Add block → Custom Liquid, where the button should go (e.g. under Add to cart).',
  'embed.install.liquid.step3': 'Paste the code below and save.',
  'embed.install.liquid.vars': "The code takes the product's details from Shopify's variables: {{ product.id }}, {{ product.handle }} and the product's featured image. The shop is your webshop address from Brand profile.",
  'embed.install.html.step1': 'Copy the code below.',
  'embed.install.html.step2': 'Paste it into your product page template, where the button should go.',
  'embed.install.html.step3': "Replace the placeholders with the product's details (using your webshop's template variables).",
  'embed.install.ph.id': 'the product id (digits only)',
  'embed.install.ph.handle': 'the product URL slug (e.g. organic-cotton-tee)',
  'embed.install.ph.img': 'the product image https URL, URL-encoded',

  // ── Fit-check embed: SRC, carts + purchases, the pixel ──
  'embed.copy.srcDone': 'SRC copied to the clipboard',
  'embed.copy.snippetDone': 'Copied: {what}',
  'embed.key.copySrc': 'Copy SRC',
  'embed.key.srcLabel': 'Iframe SRC · {platform}',
  'embed.kpi.addToCarts': 'Add to cart',
  'embed.kpi.purchases': 'Purchases',
  'embed.kpi.revenueMatched': 'Revenue with matching',
  'embed.kpi.ofWhichMatched': 'with matching: {n}',
  'embed.kpi.revenueHint': 'Purchases where the buyer viewed the matching for that product first',
  'embed.funnel.addToCartsMatched': 'Added to cart (with matching)',
  'embed.funnel.purchasesMatched': 'Purchased (with matching)',
  'embed.funnel.allCarts': 'all add-to-carts: {n}',
  'embed.funnel.allPurchases': 'all purchases: {n}',
  'embed.chart.metric.addToCarts': 'Add-to-carts',
  'embed.chart.metric.purchases': 'Purchases',
  'embed.top.col.addToCarts': 'Cart',
  'embed.top.col.purchases': 'Purchases',
  'embed.top.col.revenueMatched': 'Revenue',
  'embed.top.matched': '{n} with matching',
  'embed.event.add_to_cart': 'Added to cart',
  'embed.event.purchase': 'Purchased',
  'embed.eventFilter.add_to_cart': 'Add to cart',
  'embed.eventFilter.purchase': 'Purchase',
  'embed.visitors.qty': '{n} pcs',
  'embed.visitors.matched': 'with matching',
  'embed.visitors.matchedTitle': 'Viewed the product matching for this product first (within 30 days)',
  'embed.tracking.title': 'Cart and purchase tracking',
  'embed.tracking.lead': 'The Outfino pixel measures add-to-carts and purchases in any webshop. In the statistics the totals are every cart and purchase the pixel saw (anonymous visitors included); "with matching" are those where the same visitor viewed the product matching for that product in the 30 days before. The Visitors list shows signed-in Outfino users only.',
  'embed.tracking.platform.shopify': 'Shopify',
  'embed.tracking.platform.woocommerce': 'WooCommerce',
  'embed.tracking.platform.html': 'Other webshop (HTML)',
  'embed.tracking.lastCart': 'Last add to cart: {ago}',
  'embed.tracking.lastPurchase': 'last purchase: {ago}',
  'embed.tracking.notConfiguredHint': 'No cart or purchase events yet. Turn it on as below.',
  'embed.tracking.seenOn': 'Seen on:',
  'embed.tracking.seen.shopify': 'Shopify',
  'embed.tracking.seen.woocommerce': 'WooCommerce',
  'embed.tracking.seen.custom': 'Custom',
  'embed.tracking.shopify.step1': 'Add-to-cart on every page: Online Store → Themes → Edit code → theme.liquid. Paste this line before </body> and save.',
  'embed.tracking.shopify.step2': 'Purchases: Settings → Customer events → Add custom pixel. Name it "Outfino" and paste this code (your key is already in it).',
  'embed.tracking.woo.step1': 'Add these two lines once, to every page (e.g. with a "header/footer scripts" plugin).',
  'embed.tracking.woo.step1b': "Or without a plugin, in the theme's functions.php:",
  'embed.tracking.woo.phpTitle': 'Optional: PHP snippet for the thank-you page',
  'embed.tracking.woo.phpLead': "For the exact items and value, in the theme's functions.php or a small plugin. Without it the pixel reads the order number and total from the thank-you page.",
  'embed.tracking.html.step1': 'Put these two lines on every page of your shop, before </head>.',
  'embed.tracking.html.step2': 'Add to cart: either a data attribute on the cart button, or a call from your own cart code.',
  'embed.tracking.html.step3': 'Purchase: on the order confirmation page, once, with the order.',
  'embed.tracking.code.pixel': 'Pixel',
  'embed.tracking.code.php': 'PHP snippet',
  'embed.tracking.code.addToCart': 'Add to cart',
  'embed.tracking.code.purchase': 'Purchase',
  'embed.tracking.code.consent': 'Consent',
  'embed.tracking.consent': "In the EU, tracking may only start after the visitor's consent; until then the pixel stores and sends nothing. It follows the Shopify Customer Privacy API, the WP Consent API, Google Consent Mode and the common consent tools (Cookiebot, OneTrust, CookieYes) automatically. If none is on the page, call this after consent (false when they refuse):",
  'embed.tracking.shopify.detects': "Detects the theme's AJAX and form add-to-cart; consent follows the Shopify Customer Privacy API.",
  'embed.tracking.woo.detects': 'Detects archive AJAX and single-product add-to-cart, the Cart/Checkout blocks, and the order-received page.',
  'embed.tracking.code.functions': 'functions.php',
  'embed.tracking.code.addToCartAttr': 'Cart button (data attribute)',
  'embed.kpi.allSeen': 'all the pixel saw',
  'embed.tracking.shopify.step2b': 'Permission: Analytics, then Save and Connect.',
  'embed.tracking.code.customPixel': 'Custom pixel',
  'embed.tracking.products': 'The pixel reads the products from the page itself (Shopify catalog, WooCommerce Store API, schema.org JSON-LD), so no product sync is needed.',
  'embed.kpi.follows': 'New followers (from the iframe)',
  'embed.funnel.follows': 'follows',
  'embed.chart.metric.follows': 'New followers',
  'embed.top.col.follows': 'Follows',
  'embed.event.follow': 'Started following the brand',
  'embed.eventFilter.follow': 'Follow',
  'embed.copy.keyDone': 'Key copied to the clipboard',
  'embed.key.copyKey': 'Copy key',
  'embed.install.block.title': 'Outfino app block',
  'embed.install.block.lead': 'With the Outfino Shopify app installed, the button is a block in the theme editor.',
  'embed.install.block.step1': 'In the Shopify admin: Online Store → Customize.',
  'embed.install.block.step2': 'Pick the Product page template at the top, then Add block → Outfino.',
  'embed.install.block.step3': 'Paste your key into the block\'s "Embed key" field.',
  'embed.install.block.step4': 'Set the same shape, colour, width and height you picked above, then save.',
  'embed.tracking.app.title': 'Outfino app',
  'embed.tracking.app.lead': 'With the Outfino Shopify app installed.',
  'embed.tracking.app.step1': 'Online Store → Customize → App embeds.',
  'embed.tracking.app.step2': 'Turn on "Outfino tracking", then save.',
  'embed.tracking.app.checkout': "Orders placed at checkout are sent by the Outfino app's Web Pixel automatically.",
  'embed.tracking.paste.title': 'By pasting',
  'embed.tracking.paste.lead': 'Without the app, in any Shopify theme.',
  'embed.visitors.guest': 'Guest',
  'embed.visitors.anonymous': 'Visitor',
  'embed.visitors.identified': 'Outfino user',
  'embed.visitors.identifiedTitle': 'Signed in to Outfino in the button',
  'embed.visitors.matches': 'Matching ({n})',
  'embed.visitors.matchesShow': 'Show matching results',
  'embed.visitors.matchesHide': 'Hide matching results',
  'embed.visitors.matchesTitle': "{name}'s matching results for your products",
  'embed.visitors.matchTitle': 'Product matching: {pct} for this product',
  'embed.visitors.basis.percentile': 'Ranked against similar products for their style',
  'embed.visitors.basis.absolute': 'Based on direct style similarity',
  'embed.visitors.reason.similar_to': 'Similar to a piece in their wardrobe: {label}',
  'embed.visitors.reason.pairs_with': 'Goes well with: {label}',
  'embed.visitors.reason.none': 'No similar piece in their wardrobe to point out.',
  'embed.visitors.reason.notOpened': 'No short reason: they did not open the detailed analysis.',
  'embed.visitors.sentenceTitle': 'The exact sentence the shopper saw under the percentage.',

  // ── KYC: "Who views your products?" (aggregate demographics) ──
  'embed.kyc.title': 'Who views your products?',
  'embed.kyc.lead': 'The combined demographics of the signed-in shoppers who opened the product matching. Group-level shares only — no individual can be identified from it.',
  'embed.kyc.basedOn': 'Based on {n} shoppers',
  'embed.kyc.lowData': 'Too little data yet. The aggregate demographics appear only once at least {min} signed-in shoppers have viewed, so no one can be identified.',
  'embed.kyc.groupEmpty': 'Not enough data for this.',
  'embed.kyc.age': 'Age',
  'embed.kyc.genderTitle': 'Gender',
  'embed.kyc.styleTitle': 'Dominant style',
  'embed.kyc.unknown': 'Not given',
  'embed.kyc.gender.FEMALE': 'Women',
  'embed.kyc.gender.MALE': 'Men',
  'embed.kyc.gender.unknown': 'Not given',
  'embed.kyc.maskedLabel': 'Small groups (< {min})',
  'embed.kyc.maskedLt': '< {min}',
  'embed.kyc.maskedTitle': '{n} categories are hidden because each has too few shoppers on its own.',
  'embed.kyc.privacyNote': 'For privacy, groups smaller than {min} shoppers are not broken down further.',
  'embed.kyc.style.streetwear': 'Streetwear',
  'embed.kyc.style.techwear': 'Techwear',
  'embed.kyc.style.goth_alt': 'Goth / alternative',
  'embed.kyc.style.experimental': 'Experimental',
  'embed.kyc.style.y2k': 'Y2K',
  'embed.kyc.style.sporty': 'Sporty',
  'embed.kyc.style.casual': 'Casual',
  'embed.kyc.style.boho_indie': 'Boho / indie',
  'embed.kyc.style.minimalist': 'Minimalist',
  'embed.kyc.style.old_money': 'Old money',
  'embed.kyc.style.vintage_retro': 'Vintage / retro',

  'embed.tracking.inactive': 'Not active',
  'embed.tracking.inactiveHint': 'No cart or purchase events in the last 7 days.',
  'embed.product.untitled': 'Product #{id}',

  // ── Profile / Followers / Billing (top-level brand pages) ──
  'tab.followers': 'Followers',
  'tab.billing': 'Billing',

  'brandProfile.title': 'Brand profile',
  'brandProfile.logo': 'Logo',
  'brandProfile.logoAdd': 'Add logo',
  'brandProfile.logoChange': 'Replace logo',
  'brandProfile.logoHint': 'Shown as a circle. A square image works best.',
  'brandProfile.cover': 'Cover image',
  'brandProfile.coverAdd': 'Add cover image',
  'brandProfile.coverChange': 'Replace cover image',
  'brandProfile.nameRequired': 'The brand name cannot be empty.',
  'brandProfile.preview': 'Preview',
  'brandProfile.previewChip': 'In the fit-check button',
  'brandProfile.previewHeader': 'Header with the cover image',
  'brandProfile.tone.light': 'Light',
  'brandProfile.tone.dark': 'Dark',
  'brandProfile.follow': 'Follow',

  'followers.title': 'Followers',
  'followers.lead': 'Who follows the brand, from the app or from the fit-check button.',
  'followers.count': 'followers',
  'followers.matches': 'matches',
  'followers.search': 'Search by name or username',
  'followers.empty': 'No followers yet.',
  'followers.noMatch': 'No follower with that name.',
  'followers.col.user': 'User',
  'followers.col.source': 'Source',
  'followers.col.since': 'Following since',
  'followers.source.app': 'From the app',
  'followers.source.embed': 'From the fit-check button',
  'followers.anon': 'Anonymous follower',
  'followers.anonTitle': 'This user is not shown by name.',
  'followers.shown': '{n} of {total} shown',
  'followers.more': 'Load more',

  // Push to your followers (brand → followers push)
  'followers.push.card.title': 'Send a push to your followers',
  'followers.push.card.lead': 'Send one notification now to every follower. You write the copy, and it goes out exactly as you typed it.',
  'followers.push.open': 'Write a push',
  'followers.push.audience': 'Goes out to {n} followers',
  'followers.push.audienceOne': 'Goes out to 1 follower',
  'followers.push.audienceNone': 'You have no followers to send to yet.',
  'followers.push.titleLabel': 'Title',
  'followers.push.titlePlaceholder': 'e.g. The new collection is here',
  'followers.push.bodyLabel': 'Message',
  'followers.push.bodyPlaceholder': 'Briefly tell your followers what this is about.',
  'followers.push.count': '{n} / {max}',
  'followers.push.previewLabel': 'Preview',
  'followers.push.previewEmptyTitle': 'Title',
  'followers.push.previewEmptyBody': 'The push text shows up here.',
  'followers.push.send': 'Send now',
  'followers.push.sending': 'Sending…',
  'followers.push.cancel': 'Cancel',
  'followers.push.confirmTitle': 'Send to your followers?',
  'followers.push.confirmBody': 'Send to {n} followers? This cannot be undone.',
  'followers.push.confirmSend': 'Yes, send',
  'followers.push.quota': '{n} of {cap} sends left today.',
  'followers.push.quotaNone': "You've reached today's limit of {cap} sends.",
  'followers.push.lastSent': 'Last sent: {date}',
  'followers.push.lastSentNever': "You haven't sent a push yet.",
  'followers.push.scheduleHint': 'Scheduled sending is coming soon.',
  'followers.push.ok': 'Push sent to {n} followers.',
  'followers.push.error': "Couldn't send the push. Please try again.",
  'followers.push.errorCap': "You've reached today's send limit. Try again later.",
  'followers.push.errorForbidden': "You don't have permission, or the brand is not visible in the app yet.",
  'followers.push.errorValidation': 'Fill in the title and the message.',

  'billing.loadError': 'Could not load the billing details. Try again with Refresh.',
  'billing.readOnly': 'The brand owner can change the card and the billing details.',
  'billing.readOnlyOwner': 'Billing is managed by the brand owner.',
  'billing.cancel': 'Cancel',
  'billing.term': 'unique matching',
  'billing.terms': 'unique matchings',
  'billing.termTip': 'One user counts once per product within 30 days.',
  'billing.price.title': 'Pricing',
  'billing.price.base': 'Monthly fee: {fee} (the first month is free)',
  'billing.price.included': '{n} {terms} included',
  'billing.price.overage': 'then {price} per {term} (at most {cap} a month)',
  'billing.price.commission': '{rate} commission on purchases tied to a matching',
  'billing.usage.title': 'This month',
  'billing.usage.period': 'Month',
  'billing.usage.includedOf': '{terms}',
  'billing.usage.over': '+{n} over the included',
  'billing.usage.meterLabel': 'Unique matchings used of those included in the monthly fee',
  'billing.usage.baseFee': 'Monthly fee',
  'billing.usage.trial': 'Trial month',
  'billing.usage.overage': 'Extra matchings',
  'billing.usage.overageCalc': '{n} × {price}, at most {cap}',
  'billing.usage.overageNone': 'Within the included matchings (at most {cap})',
  'billing.usage.capReached': 'monthly cap reached',
  'billing.usage.commission': 'Commission ({rate})',
  'billing.usage.commissionCalc': '{n} purchases tied to a matching, {revenue} in sales',
  'billing.usage.estimated': 'Estimated total',
  'billing.usage.total': 'Month total',

  'billing.card.title': 'Card',
  'billing.card.lead': 'We charge the monthly fee to this card.',
  'billing.card.none': 'No card added yet.',
  'billing.card.generic': 'Card',
  'billing.card.expires': 'Expires {date}',
  'billing.card.expired': 'Expired {date}',
  'billing.card.add': 'Add card',
  'billing.card.replace': 'Replace card',
  'billing.card.remove': 'Remove',
  'billing.card.removeConfirm': 'Remove the card? Without a card we cannot charge the monthly fee.',
  'billing.card.removeYes': 'Remove',
  'billing.card.removing': 'Removing…',
  'billing.card.removed': 'Card removed',
  'billing.card.removeFailed': 'Could not remove the card. Try again.',
  'billing.card.save': 'Save card',
  'billing.card.saving': 'Saving…',
  'billing.card.saved': 'Card saved',
  'billing.card.saveFailed': 'The bank accepted the card, but saving it failed. Try again.',
  'billing.card.failed': 'The card could not be verified. Try again or use another card.',
  'billing.card.processing': 'The bank is still processing the card. Refresh the page in a few minutes.',
  'billing.card.unavailable': 'Adding a card is not available right now. Try again later.',

  'billing.mock.note': 'Test mode: no Stripe connection, nothing is charged. Test numbers: 4242 4242 4242 4242 (succeeds), 4000 0027 6000 3184 (3D Secure), 4000 0000 0000 0002 (declined).',
  'billing.mock.number': 'Card number',
  'billing.mock.expiry': 'Expiry',
  'billing.mock.expiryPh': 'MM / YY',
  'billing.mock.badNumber': 'Invalid card number.',
  'billing.mock.badExpiry': 'Invalid or past date.',
  'billing.mock.badCvc': 'Invalid CVC.',
  'billing.mock.declined': 'The card was declined.',
  'billing.mock.3dsTitle': 'Confirm with your bank',
  'billing.mock.3dsBody': 'Your bank asks you to confirm this card (3D Secure).',
  'billing.mock.3dsApprove': 'Confirm',
  'billing.mock.3dsReject': 'Decline',
  'billing.mock.3dsFailed': '3D Secure authentication failed. Try again or use another card.',

  'billing.details.title': 'Billing details',
  'billing.details.name': 'Company name',
  'billing.details.email': 'Billing e-mail',
  'billing.details.taxId': 'Tax number / VAT ID',
  'billing.details.taxIdPh': '12345678-2-42 or HU12345678',
  'billing.details.line1': 'Address',
  'billing.details.line2': 'Address line 2',
  'billing.details.postalCode': 'Postal code',
  'billing.details.city': 'City',
  'billing.details.country': 'Country',
  'billing.details.save': 'Save details',
  'billing.details.saved': 'Billing details saved',
  'billing.details.saveFailed': 'Could not save the billing details.',
  'billing.details.required': 'Required.',
  'billing.details.badEmail': 'Invalid e-mail address.',

  'billing.invoices.title': 'Invoices',
  'billing.invoices.empty': 'No invoices yet.',
  'billing.invoices.number': 'Invoice',
  'billing.invoices.period': 'Period',
  'billing.invoices.amount': 'Amount',
  'billing.invoices.status': 'Status',
  'billing.invoices.download': 'Download',
  'billing.invoices.st.paid': 'Paid',
  'billing.invoices.st.open': 'Due',
  'billing.invoices.st.draft': 'Being prepared',
  'billing.invoices.st.void': 'Voided',
  'billing.invoices.st.uncollectible': 'Charge failed',

  // ── Card gate (REQUIRE_VALID_CARD) ──
  'gate.title.missing': 'Add your card to get started',
  'gate.title.expired': 'Your card has expired',
  'gate.title.failed': 'The last charge did not go through',
  'gate.lead.missing': 'The portal opens with a verified card. The first month is free.',
  'gate.lead.expired': 'The card saved for this brand has expired. Add a new card to open the portal again.',
  'gate.lead.failed': 'The last charge to this card did not go through. Add a new card to open the portal again.',
  'gate.current': 'Saved card: •••• {last4}',
  'gate.newCard': 'Add a new card',
  'gate.memberTitle': 'The portal is not open yet',
  'gate.member': 'The brand owner has not added a card yet. Ask them so the portal opens.',
  'gate.otherBrand': 'Another brand',
  'gate.notValid.missing': 'The card could not be verified. Try again or use another card.',
  'gate.notValid.expired': 'The card has expired. Use another card.',
  'gate.notValid.failed': 'The bank did not accept the card. Use another card.',
  'gate.checkFailed': 'Could not check the card. Try again.',
  'gate.adminBanner': 'No valid card',
  'gate.status.missing': 'the brand has not added a card (you are in as an admin)',
  'gate.status.expired': "the brand's card has expired (you are in as an admin)",
  'gate.status.failed': 'the last charge did not go through (you are in as an admin)',
  'gate.errorTitle': 'Could not load billing',
  'gate.errorBody': 'Try again in a few seconds.',
  'gate.retry': 'Retry',

  // ── The webshop address (one key = one site) ──
  'embed.domain.label': 'Webshop address',
  'embed.domain.save': 'Save address',
  'embed.domain.saved': 'Set: {domain}',
  'embed.domain.change': 'Change',
  'embed.domain.first': 'Add the webshop address in Brand profile first',
  'embed.domain.confirm': 'The button will stop on the old site ({from}) and from then on only work here: {to}.',
  'embed.domain.confirmYes': 'Change address',
  'embed.domain.error.required': 'Enter the webshop address.',
  'embed.domain.error.path': 'Just the address (e.g. nova-atelier.hu), without a path, port or parameters.',
  'embed.domain.error.invalid': 'This is not a public web address. Example: nova-atelier.hu',
  'embed.domain.error.saveFailed': 'Could not save. Try again.',
  'embed.domain.error.forbidden': 'You do not have permission for this on this brand.',

  // ── Troubleshooting ──
  'embed.copy.mockLocked': 'No code can be copied from test data — the real key comes from the live portal data.',
  'embed.copy.badKey': 'The key has a wrong format, so the code cannot be copied. Refresh the page.',

  // ── Page error (PageErrorBoundary) ──
  'pageError.title': 'This page could not be shown',
  'pageError.body': 'Something went wrong. Reload the page, or pick another page in the menu.',
  'pageError.reload': 'Reload',

  // ---- Új márka (onboarding, no Shopify) + Dropok (manual products) ----
  'shell.newBrand': 'New brand',
  'onboarding.steps': 'Setup steps',
  'onboarding.step.brand': 'Brand details',
  'onboarding.step.card': 'Card',
  'onboarding.title': 'Create a new brand',
  'onboarding.lead': 'These show on your brand page and the fit-check button. Next you add your card and your 1-month free trial starts.',
  'onboarding.namePlaceholder': 'Your brand name',
  'onboarding.coverEmpty': 'Cover image (wide)',
  'onboarding.coverAdd': 'Upload cover',
  'onboarding.coverChange': 'Change cover',
  'onboarding.logoAdd': 'Upload logo',
  'onboarding.logoChange': 'Change logo',
  'onboarding.mediaHint': 'Logo (round) and cover: JPEG, PNG or WebP, up to 10 MB.',
  'onboarding.name': 'Brand name',
  'onboarding.domain': 'Webshop address',
  'onboarding.domainHint': 'Just the address, e.g. nova-atelier.hu. The fit-check button and the key only work on this site; you can change it later in Settings → Brand profile.',
  'onboarding.domainSavedAs': 'Saved as: {domain}',
  'onboarding.termsBefore': 'I accept the Outfino ',
  'onboarding.termsLink': 'partner terms',
  'onboarding.termsAfter': '.',
  'onboarding.submit': 'Create brand',
  'onboarding.creating': 'Creating…',
  'onboarding.fine': 'You add your card in the next step.',
  'onboarding.shopify': 'Have a Shopify store?',
  'onboarding.shopifyLink': 'Connect Shopify',
  'onboarding.cancel': 'Back',
  'onboarding.card.title': 'Add your card – your 1-month free trial starts',
  'onboarding.card.lead': 'The first month is free. The trial starts when the card is verified; after that the monthly fee is charged to this card.',
  'onboarding.trialStarted': 'Your trial has started',
  'onboarding.error.limit': 'You have reached the number of brands you can create. Write to us if you want to start another one.',
  'onboarding.error.rateLimited': 'Too many attempts. Try again in an hour.',
  'onboarding.error.rateLimitedFor': 'Too many attempts. Try again in {min} min.',
  'onboarding.error.guest': 'A guest account cannot create a brand. Sign in with your own account.',
  'onboarding.error.signedOut': 'Your session has expired. Sign in again.',
  'onboarding.error.failed': 'Could not create the brand. Try again.',
  'onboarding.error.name.required': 'Enter the brand name.',
  'onboarding.error.name.tooLong': 'The name can be at most {max} characters.',
  'onboarding.error.name.invalid': 'The name cannot contain line breaks or control characters.',
  'onboarding.error.logo.required': 'Upload a logo.',
  'onboarding.error.logo.type': 'The logo must be a JPEG, PNG or WebP image.',
  'onboarding.error.logo.size': 'The logo can be at most 10 MB (and 40 megapixels).',
  'onboarding.error.logo.corrupt': 'The logo file is damaged or incomplete. Pick another one.',
  'onboarding.error.cover.required': 'Upload a cover image.',
  'onboarding.error.cover.type': 'The cover must be a JPEG, PNG or WebP image.',
  'onboarding.error.cover.size': 'The cover can be at most 10 MB (and 40 megapixels).',
  'onboarding.error.cover.corrupt': 'The cover file is damaged or incomplete. Pick another one.',
  'onboarding.error.domain.required': 'Enter your webshop address.',
  'onboarding.error.domain.path': 'Just the address (e.g. nova-atelier.hu), no path, port or parameters.',
  'onboarding.error.domain.invalid': 'This is not a public web address. Example: nova-atelier.hu',
  'onboarding.error.terms.required': 'Accept the partner terms to continue.',
  'onboarding.error.terms.version': 'The terms version was not accepted. Reload the page.',
  'drops.lead': 'Put a drop together: a name, a description, one or more uploaded products and the time. From its start the drop is live in the Outfino app for 24 hours.',
  'drops.emptyHint': 'With “New drop” you upload products, name the drop and choose when it starts.',
  'drops.loadFailed': 'Could not load the drops.',
  'drops.delete': 'Delete',
  'drops.deleteConfirm': 'Delete this drop? Its “notify me” sign-ups are removed too.',
  'drops.deleteConfirmActive': 'This drop is live. Deleting it removes it from the app right away.',
  'drops.deleteYes': 'Delete',
  'drops.deleting': 'Deleting…',
  'drops.deleted': 'The drop was deleted.',
  'drops.flow.pick': 'Uploaded products ({n})',
  'drops.flow.start': 'Starts',
  'drops.flow.end': 'Ends',
  'drops.flow.endHint': 'The drop is live for 24 hours from its start.',
  'drops.flow.created': 'Drop scheduled: {date}.',
  'drops.flow.pastDate': 'The start must be in the future.',
  'drops.flow.forbidden': 'You don’t have permission for this on this brand.',
  'drops.upload.title': 'Upload a product',
  'drops.upload.lead': 'Photos, name, price and sizes. The AI analyses the product right away (category, style, labels).',
  'drops.upload.photos': 'Photos',
  'drops.upload.main': 'Main',
  'drops.upload.makeMain': 'Make this the main photo',
  'drops.upload.remove': 'Remove photo',
  'drops.upload.add': 'Add photos',
  'drops.upload.addMore': 'More photos',
  'drops.upload.photosHint': '1–{max} images, JPEG, PNG or WebP, up to 10 MB each. The first one is the main photo.',
  'drops.upload.name': 'Product name',
  'drops.upload.price': 'Price',
  'drops.upload.currency': 'Currency',
  'drops.upload.sizes': 'Sizes',
  'drops.upload.sizesHint': 'Comma-separated, e.g. S, M, L. Optional.',
  'drops.upload.description': 'Description (optional)',
  'drops.upload.submit': 'Upload and analyse',
  'drops.upload.uploading': 'Uploading…',
  'drops.upload.uploadingHint': 'Uploading the photos while the AI analyses the product. This takes a few seconds.',
  'drops.upload.error.rateLimited': 'You have uploaded many products this hour. Try again later.',
  'drops.upload.error.rateLimitedFor': 'You have uploaded many products this hour. Try again in {min} min.',
  'drops.upload.error.forbidden': 'You don’t have permission to upload products on this brand.',
  'drops.upload.error.failed': 'Could not upload the product. Try again.',
  'drops.upload.error.images.required': 'Add at least one photo.',
  'drops.upload.error.images.tooMany': 'You can upload at most {max} photos.',
  'drops.upload.error.images.type': 'Only JPEG, PNG or WebP images can be uploaded.',
  'drops.upload.error.images.size': 'An image can be at most 10 MB (and 40 megapixels).',
  'drops.upload.error.images.corrupt': 'One of the images is damaged or incomplete. Replace it.',
  'drops.upload.error.images.typeAt': 'Photo {n} is not a JPEG, PNG or WebP. Replace it.',
  'drops.upload.error.images.sizeAt': 'Photo {n} is too large (up to 10 MB and 40 megapixels).',
  'drops.upload.error.images.corruptAt': 'Photo {n} is damaged or incomplete. Replace it.',
  'drops.upload.error.images.tooManyAt': 'You can upload at most {max} photos.',
  'drops.upload.error.images.typeNamed': '“{name}” is not a JPEG, PNG or WebP image, so it was left out.',
  'drops.upload.error.images.sizeNamed': '“{name}” is larger than 10 MB, so it was left out.',
  'drops.upload.error.name.required': 'Enter the product name.',
  'drops.upload.error.name.tooLong': 'The name can be at most 255 characters.',
  'drops.upload.error.name.invalid': 'This name was not accepted.',
  'drops.upload.error.price.required': 'Enter the price.',
  'drops.upload.error.price.invalid': 'The price must be above 0 with at most 2 decimals (e.g. 49990 or 49.90).',
  'drops.upload.error.currency.invalid': 'Pick a currency.',
  'drops.upload.error.sizes.tooMany': 'You can add at most 30 sizes.',
  'drops.upload.error.sizes.tooLong': 'A size can be at most 32 characters.',
  'drops.upload.error.sizes.invalid': 'The sizes were not accepted. Check them.',
  'drops.upload.error.description.tooLong': 'The description can be at most 5000 characters.',
  'drops.upload.error.description.invalid': 'The description was not accepted.',
  'drops.ai.pending': 'AI analysis in progress',
  'drops.ai.clothing': 'AI analysis done',
  'drops.ai.notClothing': 'Not a clothing product',
  'drops.ai.failed': 'The AI analysis failed',
  'drops.ai.pendingHint': 'Queued; the result shows up here by itself.',
  'drops.ai.notClothingHint': 'The AI says this is not clothing, so it cannot go into a drop. Upload another product.',
  'drops.ai.failedHint': 'Try again later, or upload another photo.',
  'drops.ai.category': 'Category',
  'drops.ai.style': 'Style',
  'drops.ai.tag.type': 'Type',
  'drops.ai.tag.color': 'Colour',
  'drops.ai.tag.pattern': 'Pattern',
  'drops.ai.tag.material': 'Material',
  'drops.ai.tag.fit': 'Fit',
  'drops.ai.tag.length': 'Length',
  'drops.edit.open': 'Edit',
  // ---- Webshop address in Márkaprofil, troubleshooting ----
  'embed.domain.goProfile': 'Go to Brand profile',
  'embed.domain.notSet': 'Not set yet',
  'embed.domain.hint': 'The fit-check button and the key only work on this address (and its www. form). Set it first, then you can copy the codes.',
  'embed.domain.loadFailed': 'Could not load the webshop address. Refresh the page.',
  // ---- /embedding-problems (public) ----
  'problems.title': 'Embedding problems',
  'problems.eyebrow': 'Outfino fit-check button',
  'problems.lead': 'If a message shows in place of the button on your webshop, or you do not see the button at all, here is what it means and what to do, step by step.',
  'problems.index': 'Problems',
  'problems.language': 'Language',
  'problems.openPortal': 'Partner portal',
  'problems.permalink': 'Link to this problem',
  'problems.contact': 'Not listed, or the steps did not help? Write to us:',
  'problems.mailSubject': 'Fit-check button: embedding problem',
  'problems.where.frame': 'In place of the button',
  'problems.where.portal': 'In the partner portal',
  'problems.where.symptom': 'Symptom',
  'problems.link.domain': 'Brand profile → Webshop address',
  'problems.link.settings': 'Settings → Embed code',
  'problems.link.billing': 'Billing',
  'problems.link.drops': 'Drops',
  'problems.link.mail': '{email}',
  'problems.DOMAIN_NOT_SET.short': 'No webshop address',
  'problems.DOMAIN_NOT_SET.msg': 'The brand has not set its web shop address yet.',
  'problems.DOMAIN_NOT_SET.means': 'The key only works on the webshop address set in Brand profile, and none is set yet.',
  'problems.DOMAIN_NOT_SET.step1': 'Set your webshop address in the partner portal:',
  'problems.DOMAIN_NOT_SET.step2': 'Enter just the address (e.g. nova-atelier.hu), without a path, and save.',
  'problems.DOMAIN_NOT_SET.step3': 'Refresh the product page: the button shows up within a few minutes.',
  'problems.KEY_NOT_ALLOWED.short': 'Another site',
  'problems.KEY_NOT_ALLOWED.msg': 'This key belongs to another shop.',
  'problems.KEY_NOT_ALLOWED.means': 'The code runs on a different site than the webshop address in Brand profile. The key only works on that address (and its www. form).',
  'problems.KEY_NOT_ALLOWED.step1': 'Check which address is set:',
  'problems.KEY_NOT_ALLOWED.step2': 'If it is wrong, change it to your real webshop address, save, and copy the code again.',
  'problems.KEY_NOT_ALLOWED.step3': 'If it is right, use the code on that site only (another webshop needs another brand).',
  'problems.BRAND_INACTIVE.short': 'Inactive brand',
  'problems.BRAND_INACTIVE.msg': 'This brand is not active on Outfino right now.',
  'problems.BRAND_INACTIVE.means': 'The button only works for an active brand: it needs a valid card and at least one active product.',
  'problems.BRAND_INACTIVE.step1': 'Add a card:',
  'problems.BRAND_INACTIVE.step2': 'Have at least one active product (e.g. a drop, or a product picked up from your webshop):',
  'problems.BRAND_INACTIVE.step3': 'Refresh the product page: it works again within a few minutes.',
  'problems.BRAND_INACTIVE.causes': 'If your card and your active product are both in order, Outfino may have suspended the brand: the partner portal says so at the top. Only we can lift a suspension; if you have a question, write to us.',
  'problems.KEY_NOT_FOUND.short': 'Invalid key',
  'problems.KEY_NOT_FOUND.msg': 'Invalid Outfino key.',
  'problems.KEY_NOT_FOUND.means': 'The key in the code does not exist, or it has been replaced.',
  'problems.KEY_NOT_FOUND.causes': 'Common causes: the code was copied from the test (dev) portal or from test data, an old code stayed on the page, or the key was mistyped.',
  'problems.KEY_NOT_FOUND.step1': 'Copy the code again from the live portal:',
  'problems.KEY_NOT_FOUND.step2': 'Replace the old code with it on your webshop.',
  'problems.KEY_NOT_FOUND.step3': 'Save, and refresh the product page.',
  'problems.MISSING_KEY.short': 'Missing key',
  'problems.MISSING_KEY.msg': 'The Outfino button is not set up: the embed code has no key.',
  'problems.MISSING_KEY.means': 'The pasted code has no brand key, so the button does not know whose it is.',
  'problems.MISSING_KEY.step1': 'Copy the whole code again:',
  'problems.MISSING_KEY.step2': 'Replace the old code with it on your webshop (Shopify: in the product page’s “Custom Liquid” block).',
  'problems.MISSING_KEY.step3': 'Save, and refresh the product page.',
  'problems.POPUP_BLOCKED.short': 'Blocked window',
  'problems.POPUP_BLOCKED.msg': 'Your browser did not let the sign-in window open.',
  'problems.POPUP_BLOCKED.means': 'Google and Apple sign-in open in a separate window, and the shopper’s browser blocked it.',
  'problems.POPUP_BLOCKED.step1': 'In the address bar, click the blocked pop-up icon.',
  'problems.POPUP_BLOCKED.step2': 'Allow pop-ups for this webshop.',
  'problems.POPUP_BLOCKED.step3': 'Click sign-in again, or use the “Sign in in a new tab” link under the button.',
  'problems.NOT_SEEN.short': 'Not set up',
  'problems.NOT_SEEN.msg': 'Not set up',
  'problems.NOT_SEEN.means': 'We have not seen the button on a live page in the last 7 days (no impressions).',
  'problems.NOT_SEEN.step1': 'Check that the code is on a live product page, not just in a preview or a draft.',
  'problems.NOT_SEEN.step2': 'Save the theme or page change; if the site uses a cache (CDN), clear it.',
  'problems.NOT_SEEN.step3': 'Open a product page; within a few minutes the portal shows it too:',
  'problems.SHOPIFY_NOT_SHOWN.short': 'Shopify: not showing',
  'problems.SHOPIFY_NOT_SHOWN.msg': 'Shopify: the button does not show on the product page',
  'problems.SHOPIFY_NOT_SHOWN.means': 'The code is not in the product page template, or the edited theme is not published.',
  'problems.SHOPIFY_NOT_SHOWN.step1': 'In the Shopify admin: Online Store → Themes → Customize.',
  'problems.SHOPIFY_NOT_SHOWN.step2': 'Pick the Product template at the top and check that the “Custom Liquid” block with the code is there.',
  'problems.SHOPIFY_NOT_SHOWN.step3': 'If you edited a copy of the theme, publish it.',
  'problems.UNKNOWN.short': 'Unknown error',
  'problems.UNKNOWN.msg': 'Unknown error',
  'problems.UNKNOWN.means': 'The button reports a problem that is not listed above, or the steps did not help.',
  'problems.UNKNOWN.step1': 'Refresh the product page, and try another browser too.',
  'problems.UNKNOWN.step2': 'Take a screenshot of the problem and copy the product page address.',
  'problems.UNKNOWN.step3': 'Send them to us and we will help:',
  'embed.troubleLink': 'Is the button showing an error? Embedding problems and fixes',
  // ---- Dropok v2 (drop groups) ----
  'drops.notClothing.title': 'This does not look like clothing – upload another photo',
  'drops.notClothing.body': 'The AI does not see clothing in the photo, so this product cannot go into a drop.',
  'drops.notClothing.replace': 'Replace photo',
  'drops.notClothing.other': 'Upload another product instead',
  'drops.product.edit': 'Edit product',
  'drops.product.up': 'Move up',
  'drops.product.down': 'Move down',
  'drops.product.remove': 'Remove from the drop',
  'drops.edit.photosHint': 'New photos go after the current ones. If the photos, the name or the description change, the AI analyses the product again.',
  'drops.edit.reanalyzeHint': 'Changing the price, the currency or the sizes does not start a new AI analysis.',
  'drops.edit.saveProduct': 'Save product',
  'drops.upload.error.gone': 'This product no longer exists. Upload a new one.',
  'drops.group.editTitle': 'Edit drop',
  'drops.group.startedNote': 'The drop has started: its name, description and end can still change, its products and start cannot.',
  'drops.group.details': 'Drop details',
  'drops.group.name': 'Drop name',
  'drops.group.namePlaceholder': 'e.g. Winter capsule',
  'drops.group.description': 'Description (optional)',
  'drops.group.descriptionPlaceholder': 'A few lines about the drop; shoppers see it in the app.',
  'drops.group.products': 'Products',
  'drops.group.noProducts': 'No product in the drop yet. Upload one, or pick from the ones uploaded earlier.',
  'drops.group.pickTitle': 'Uploaded products',
  'drops.group.nothingToPick': 'No more products to add.',
  'drops.group.unnamed': 'Unnamed drop',
  'drops.group.productCount': '{n} product(s)',
  'drops.group.save': 'Save changes',
  'drops.group.saved': 'The drop was saved.',
  'drops.group.subscribers': '{n} subscriber(s)',
  'drops.group.error.name.required': 'Enter the drop’s name.',
  'drops.group.error.name.tooLong': 'The name can be at most {max} characters.',
  'drops.group.error.products.required': 'Add at least one product.',
  'drops.group.error.products.tooMany': 'A drop can hold at most 50 products.',
  'drops.group.error.products.pending': 'Wait until the AI has analysed every product.',
  'drops.group.error.products.notClothing': 'A product is not clothing: replace its photo, or take it out of the drop.',
  'drops.group.error.start.required': 'Choose when the drop starts.',
  'drops.group.error.start.past': 'The start must be in the future.',
  'drops.groupError.product.notClothing': 'The AI says this is not clothing, so it cannot go into a drop.',
  'drops.groupError.product.pending': 'The AI is still analysing this product. Try again in a few minutes.',
  'drops.groupError.product.notDroppable': 'This product is already visible in the catalog, so it cannot go into a drop.',
  'drops.groupError.product.inOtherDrop': 'This product is already in another scheduled or live drop.',
  'drops.groupError.product.notFound': 'This product no longer exists. Take it out of the drop.',
  'drops.groupError.INVALID_NAME': 'The drop name was not accepted.',
  'drops.groupError.INVALID_DESCRIPTION': 'The description can be at most 2000 characters.',
  'drops.groupError.INVALID_STARTS_AT': 'The start is not valid.',
  'drops.groupError.DROP_DATE_IN_PAST': 'The start must be in the future.',
  'drops.groupError.INVALID_PRODUCT_IDS': 'A drop holds 1–50 products.',
  'drops.groupError.DROP_ALREADY_STARTED': 'The drop has started: its products and start cannot change.',
  'drops.groupError.DROP_CLOSED': 'This drop has closed.',
  'drops.flow.endKept': 'This drop has an end set earlier.',
  // ---- Billing optional + not-connected nudges (2026-11) ----
  'badge.billing': 'Set up billing',
  'badge.connect': 'Connect Outfino on your webshop',
  'billing.setupNote': 'Set up billing so the service keeps running after the trial. You can use the rest of the portal without it.',
  'embed.notConnected.stats': 'The button is not set up on your webshop yet. It only takes a few minutes.',
  'embed.notConnected.cta': 'Get set up',
  'onboarding.brandCreated': 'Your brand is ready',

  // ---- Onboarding (guided setup) ----
  'tab.onboarding': 'Get started',
  'group.onboarding': 'Get started',
  'badge.onboarding': 'Finish getting set up',
  'onboarding.hero.title': 'Get started',
  'onboarding.hero.lead': 'A few steps and the Outfino try-on button is live on your webshop. Work through them in order — each step expands.',
  'onboarding.progress': '{n}/{total} done',
  'onboarding.optional': 'optional',
  'onboarding.done.title': "You're live on Outfino!",
  'onboarding.done.body': 'The button is live in your shop and your products are loaded. Stats will appear shortly.',

  'onboarding.billing.title': 'Set up billing',
  'onboarding.billing.why': 'So the service keeps running after the trial — everything works without it too.',
  'onboarding.billing.body': 'Billing is optional, but adding a card keeps the service running after the trial ends.',
  'onboarding.billing.cta': 'Go to Billing',

  'onboarding.button.title': 'Add the button to your webshop',
  'onboarding.button.why': "This is Outfino's “See if it suits you” button on the product page.",
  'onboarding.button.body': 'Set your webshop address, then paste the code onto your product page. The design and the code are below, per platform.',

  'onboarding.products.title': 'Upload or fetch your products',
  'onboarding.products.why': 'So the button can match your own products.',
  'onboarding.products.body': 'We pull products from your webshop address (your own site only) and prepare them for matching. We understand Shopify and sitemap-based shops.',
  'onboarding.products.have': '{n} products are currently loaded.',
  'onboarding.products.crawl': 'Fetch products',
  'onboarding.products.crawling': 'Fetching…',
  'onboarding.products.view': 'View products',
  'onboarding.products.needDomain': 'First set your webshop address in step 2.',
  'onboarding.products.unavailable': 'Product fetching is coming soon. Until then, upload products on the Products page.',
  'onboarding.products.progress': 'Found: {found} · Loaded: {ingested}',
  'onboarding.products.phase.queued': 'Preparing…',
  'onboarding.products.phase.discovering': 'Finding products…',
  'onboarding.products.phase.ingesting': 'Loading products…',
  'onboarding.products.phase.done': 'Done',
  'onboarding.products.crawlDone': 'Done! {n} products loaded.',
  'onboarding.products.error.NO_PRODUCTS': "We couldn't find products at this address. Check your webshop address, or upload them manually.",
  'onboarding.products.error.DOMAIN_NOT_SET': 'The webshop address is not set. Add it in step 2.',
  'onboarding.products.error.CRAWL_FAILED': "The fetch didn't work. Please try again shortly.",

  'onboarding.test.title': 'Test it',
  'onboarding.test.why': 'We check live whether the button works in your shop.',
  'onboarding.test.body': 'The Test button runs the checks and shows what is done and what is missing.',
  'onboarding.test.run': 'Test',
  'onboarding.test.running': 'Testing…',
  'onboarding.test.pass': 'Done! The Outfino button is live in your shop.',
  'onboarding.test.fail': 'The button is not live yet. See the checks below.',
  'onboarding.test.degraded': 'Simplified check (the detailed test is coming soon).',
  'onboarding.test.error.KEY_NOT_FOUND': 'No valid key. Paste the code again from step 2.',
  'onboarding.test.error.DOMAIN_NOT_SET': 'The webshop address is not set. Add it in step 2.',
  'onboarding.test.error.BRAND_INACTIVE': 'The brand cannot run the button yet. Please get in touch.',
  'onboarding.test.error.KEY_NOT_ALLOWED': 'The button runs on a different address than the one you set. Check your webshop address.',
  'onboarding.test.error.NO_IMPRESSIONS': 'No impression yet. Open the button on one of your product pages.',
  'onboarding.check.keyValid': 'Valid key',
  'onboarding.check.domainSet': 'Webshop address set',
  'onboarding.check.brandActive': 'The brand can run the button',
  'onboarding.check.impressionSeen': 'The button appeared in the shop',
  'onboarding.check.eventsSeen': 'Visitor interaction received',
  'onboarding.check.pixelSeen': 'Purchase tracking (pixel) active',
  'onboarding.check.fix': 'Fix',
  'onboarding.check.learn': 'Learn more',
  'onboarding.check.lastSeen': 'last seen {ago}',
  'onboarding.check.hint.keyValid': 'The key is missing or invalid.',
  'onboarding.check.hint.domainSet': 'The webshop address is not set.',
  'onboarding.check.hint.brandActive': 'The brand cannot run the button yet.',
  'onboarding.check.hint.impressionSeen': "We haven't seen an impression in your shop yet — add the button and open a product.",
  'onboarding.check.hint.eventsSeen': 'No visitor interaction from the button yet.',
  'onboarding.check.hint.pixelSeen': "We haven't seen the pixel fire yet.",
  // Teszt-gated status + the button sub-steps (accordion)
  'onboarding.untested': "You haven't run a test yet. Press “Test” to see what's working.",
  'onboarding.test.loadError': 'Could not run the test. Try again.',
  'onboarding.sub.key.title': 'Embed key',
  'onboarding.sub.key.body': "This is your brand's publishable key (ofk_live_…). The code already includes it; copy it if you need it separately.",
  'onboarding.sub.code.title': 'The button code on the product page',
  'onboarding.sub.code.body': 'Paste the code onto your product page where the button should appear — per platform (Shopify / other webshop).',
  'onboarding.sub.domain.title': 'Webshop address',
  'onboarding.sub.domain.body': 'Set your webshop address — the button only runs on that address (and its www. form) where it appears.',
  'onboarding.sub.pixel.title': 'Pixel (purchase tracking)',
  'onboarding.sub.pixel.body': 'If you want to measure add-to-cart and purchases, add the pixel too — optional.',
  'onboarding.sub.hint.key': 'The key is missing or invalid. Paste the code again.',
  'onboarding.sub.hint.code': "We haven't seen an impression in your shop yet — add the button and open a product page.",
  'onboarding.sub.hint.domain': 'The webshop address is not set. Add it.',
  'onboarding.sub.hint.domainMismatch': 'The button runs on a different address than the one you set. Check your webshop address.',
  'onboarding.sub.hint.pixel': "We haven't seen the pixel fire yet. Add the pixel code for purchase tracking.",
};

export default en;
